<template>
  <div class="document-invite">
    <!-- メインヒーローバナー -->
    <div class="hero-section">
      <!-- PC版用のコンテンツコンテナ -->
      <div class="hero-content">
        <!-- メインタイトル -->
        <div class="hero-title-container">
          <div class="title-background">
            <img src="/img/newlp_bg_dod.webp" alt="右上背景" class="title-bg-image" />
          </div>
          <!-- 左上の背景画像 -->
          <div class="title-bg-top-left">
            <img src="/img/newlp_bg_dod.webp" alt="左上背景" class="title-bg-top-left-image" />
          </div>
          <img
            src="/img/newlp_titlelogo.webp"
            alt="ファンとつながるグッズ販売"
            class="title-logo"
          />
        </div>

        <!-- 中央のメインビジュアル -->
        <!-- 中央左の背景画像 -->
        <div class="main-visual-bg-center-left">
          <img src="/img/newlp_bg_dod.webp" alt="真ん中左背景" class="main-visual-bg-image" />
        </div>
        <!-- 中央右の背景画像 -->
        <div class="main-visual-bg-center-right">
          <img src="/img/newlp_bg_dod.webp" alt="真ん中右背景" class="main-visual-bg-image" />
        </div>

        <!-- 左下の背景画像 -->
        <div class="hero-main-visual">
          <div class="main-visual-bg-left">
            <img src="/img/newlp_bg_dod.webp" alt="背景" class="main-visual-bg-image" />
          </div>
          <!-- 右下の背景画像 -->
          <div class="main-visual-bg-right dispay-dod">
            <img src="/img/newlp_bg_dod.webp" alt="背景" class="main-visual-bg-image dispay-dod" />
          </div>

          <img
            v-if="windowWidth <= 599"
            src="/img/newlp_sp_mv.webp"
            alt="メインビジュアル"
            class="main-visual-image"
          />
          <img
            v-else
            src="/img/newlp_MV_PC2.webp"
            alt="メインビジュアル"
            class="main-visual-image"
          />
        </div>

        <!-- メッセージ -->
        <div class="hero-messages">
          <p class="hero-message-main hero-message-main-tb">
            <span class="message-part1">グッズ販売中にファンと</span>
          </p>
        </div>
        <div class="hero-messages-part2">
          <p class="hero-message-main">
            <span class="message-part2">リアルタイムで繋がれる！</span>
          </p>
        </div>
      </div>
      <!-- PC版用のコンテンツコンテナ -->
      <div class="hero-content">
        <div class="hero-message-sub">
          グッズ販売が、もっと<span class="highlight-text">“つながる”</span>イベントに。
        </div>
      </div>
    </div>
    <!-- アクションセクション -->
    <div class="action-section">
      <div class="action-container">
        <!-- PDFで資料を見る -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv1.webp" alt="PDF資料" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼詳しい情報はこちらから！／</h3>
            <button v-if="documentId" class="action-button pdf-button" @click="onPdf">
              PDFで資料を見る
              <span class="arrow">▶</span>
            </button>
            <button v-else class="action-button pdf-button" @click="openModal">
              資料を見る / 参加申し込み
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>

        <!-- LINEで相談する -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv2.webp" alt="LINE相談" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼お気軽にご相談ください！／</h3>
            <button class="action-button line-button" @click="onLine">
              LINEで相談する
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>

        <!-- オンライン説明を予約する -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv3.webp" alt="オンライン説明" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼直接説明を受けたい方へ！／</h3>
            <button class="action-button online-button" @click="onReserve">
              オンライン説明を予約する
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- フッターロゴ -->
  <div class="action-footer">
    <span class="footer-logo">SUKISUKI LIVE STATION</span>
  </div>

  <div class="moyamoya">
    <div class="section-moyamoya" v-if="windowWidth <= 749">
      <div class="moyamoya-title-wrap">
        <img src="/img/newlp_nayami1.webp" alt="モヤモヤ左" class="moyamoya-left-icon" />
        <h3>
          グッズ販売、<br />こんな<span style="font-size: 16px; color: white; text-shadow: none"
            >「モヤモヤ」</span
          >ありませんか？
        </h3>
        <img src="/img/newlp_nayami2.webp" alt="モヤモヤ右" class="moyamoya-right-icon" />
        <img src="/img/newlp_bg_dod.webp" alt="背景" class="moyamoya-bg-right" />
      </div>
    </div>

    <div class="section-moyamoya" v-else>
      <div class="moyamoya-title-wrap">
        <img src="/img/newlp_nayami1.webp" alt="モヤモヤ左" class="moyamoya-left-icon" />
        <h3>
          グッズ販売、こんな<span
            class="moyamoya-title-highlight"
            style="font-size: 32px; color: white; text-shadow: none"
            >「モヤモヤ」</span
          >ありませんか？
        </h3>
        <img src="/img/newlp_nayami2.webp" alt="モヤモヤ右" class="moyamoya-right-icon" />
        <img src="/img/newlp_bg_dod.webp" alt="背景" class="moyamoya-bg-right" />
        <img src="/img/newlp_bg_dod.webp" alt="背景" class="moyamoya-bg-left" />
      </div>
    </div>

    <!-- 配信者と視聴者の1列レイアウト -->
    <div class="moyamoya-two-column">
      <!-- 配信者セクション -->
      <div class="moyamoya-column">
        <div class="moyamoya-person">
          <img src="/img/newlp_nayamihaisin.webp" alt="配信者" class="person-avatar-image" />
        </div>
        <div class="moyamoya-concerns">
          <div class="concern-item concern-item-hidari">
            <div class="concern-title">誰が買ってくれたかが<br />"すぐ"にわからない...</div>
            <div class="concern-desc">
              どのファンがどれだけ<br />グッズ購入してくれたかが、<br />すぐにわからない。
            </div>
          </div>
          <div class="concern-item concern-item-naka">
            <div class="concern-title">感謝を伝えるタイミングを<br />逃してしまう...</div>
            <div class="concern-desc">
              ただ販売するだけで、<br />お礼を伝える機会を逃しがち。<br />もっと購入=応援してくれた<br />感謝を伝えたい。
            </div>
          </div>
          <div class="concern-item concern-item-migi">
            <div class="concern-title">グッズ販売がただの物販で<br />終わってしまう...</div>
            <div class="concern-desc">
              コメントやスパチャは<br />応援として盛り上がるのに、<br />グッズ販売はただの<br />物販として終わってしまう。
            </div>
          </div>
        </div>
      </div>

      <!-- 視聴者セクション -->
      <div class="moyamoya-column">
        <div class="moyamoya-person">
          <img src="/img/newlp_nayamisityou.webp" alt="視聴者" class="person-avatar-image" />
        </div>
        <div class="moyamoya-concerns">
          <div class="concern-item concern-item-hidari">
            <div class="concern-title">応援が届いている<br />実感がない...</div>
            <div class="concern-desc">
              購入しても気づいて<br />もらえないのではという不安。<br />せっかく買っても孤独な応援に。
            </div>
          </div>
          <div class="concern-item concern-item-naka">
            <div class="concern-title">推しのリアルタイムな<br />反応がみたい</div>
            <div class="concern-desc">
              推しに応援が届いたことを<br />その場で知りたい、<br />推しの反応に共感したい。
            </div>
          </div>
          <div class="concern-item concern-item-migi concern-item-migi-d">
            <div class="concern-title">推し活に楽しさや<br />参加感がほしい</div>
            <div class="concern-desc">
              ただ買うだけじゃなくて、<br />グッズ販売イベントに<br />参加してる感じが欲しい。<br />ワクワクできる<br />"応援体験"があれば、<br />もっと楽しいのに。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PC用の右側の縦書きテキスト -->
  <div v-if="windowWidth >= 1081" class="vertical-title-right">SUKISUKI LIVE STATION</div>

  <!-- SUKISUKI LIVE STATIONセクション -->
  <div class="live-station-section">
    <!-- 左側の縦書きテキスト -->
    <div class="vertical-title">SUKISUKI LIVE STATION</div>
    <!-- 上部の三角形バナー -->
    <div class="live-station-header">
      <div v-if="windowWidth >= 1081" class="title-bg-live-left">
        <img src="/img/newlp_bg_dod.webp" alt="左上背景" class="title-bg-top-left-image" />
      </div>
      <div class="header-triangle">
        <img
          v-if="windowWidth <= 749"
          src="/img/newlp_ap_arrow.webp"
          alt="Arrow background"
          class="header-arrow-image"
        />
        <img v-else src="/img/newlp_arrow.webp" alt="Arrow background" class="header-arrow-image" />
        <div class="header-characters">
          <div class="character-keychain">
            <img
              src="/img/newlp_goods1.webp"
              alt="Character 1"
              class="character-image character-image-keychain"
            />
          </div>
          <div class="character-peek">
            <img
              src="/img/newlp_goods2.webp"
              alt="Character 2"
              class="character-image character-image-peek"
            />
          </div>
        </div>
        <div v-if="windowWidth <= 749" class="header-text">
          <div class="header-text-main">そんなモヤモヤにこたえるのが、</div>
          <div class="header-text-sub">配信中の</div>
          <div class="header-text-highlight">"リアルタイムくじ引き"</div>
        </div>
        <div v-else class="header-text">
          <div class="header-text-main">そんなモヤモヤにこたえるのが、</div>
          <div class="header-text-highlight">
            <span class="header-text-highlight-sub">配信中の</span
            ><span class="header-text-highlight-underline">"リアルタイムくじ引き"</span>
          </div>
        </div>
      </div>
    </div>
    <!-- アイコンセクション -->
    <div class="live-station-icons-section">
      <div class="icon-container">
        <div class="realtimekuji-container">
          <img
            src="/img/newlp_realtimekuji.webp"
            alt="Real-time lottery"
            class="realtimekuji-image"
          />
        </div>
      </div>
    </div>

    <!-- BG1セクション -->
    <div v-if="windowWidth >= 1081" class="bg-1-section stick-hidden">
      <div class="bg-1-container">
        <img src="/img/newlp_bg_1.webp" alt="Background 1" class="bg-1-image" />
      </div>
    </div>

    <!-- ロゴセクション -->
    <div class="live-station-logo-section">
      <div class="logo-container">
        <img
          src="/img/newlp_sukisukilogo.webp"
          alt="SUKISUKI LIVE STATION"
          class="sukisuki-logo-image"
        />
      </div>
      <div class="logo-description">
        応援がその場で届く、<br />
        新しいグッズ販売のカタチです。
      </div>
    </div>

    <!-- キャラクター画像セクション -->
    <!-- PC版用のコンテンツコンテナ -->
    <div class="hero-content">
      <div class="character-images-section">
        <div class="character-image-left">
          <img
            src="/img/newlp_man1.webp"
            alt="Character Man"
            class="character-image character-image-1"
          />
        </div>
        <div class="character-image-right">
          <img
            src="/img/newlp_odoroki.webp"
            alt="Character Odoroki"
            class="character-image character-image-2"
          />
        </div>
      </div>
    </div>

    <!-- アクションセクション -->
    <div class="action-section-naka">
      <div class="action-container-naka">
        <!-- PDFで資料を見る -->
        <!-- PDFで資料を見る -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv1.webp" alt="PDF資料" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼詳しい情報はこちらから！／</h3>
            <button v-if="documentId" class="action-button pdf-button" @click="onPdf">
              PDFで資料を見る
              <span class="arrow">▶</span>
            </button>
            <button v-else class="action-button pdf-button" @click="openModal">
              資料を見る / 参加申し込み
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>

        <!-- LINEで相談する -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv2.webp" alt="LINE相談" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼お気軽にご相談ください！／</h3>
            <button class="action-button line-button" @click="onLine">
              LINEで相談する
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>

        <!-- オンライン説明を予約する -->
        <div class="action-item">
          <div class="action-icon">
            <img src="/img/newlp_cv3.webp" alt="オンライン説明" class="action-icon-image" />
          </div>
          <div class="action-content">
            <h3 class="action-title">＼直接説明を受けたい方へ！／</h3>
            <button class="action-button online-button" @click="onReserve">
              オンライン説明を予約する
              <span class="arrow">▶</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BG1セクション（PC版用） -->
  <div class="bg-1-section-left stick-hidden">
    <div class="bg-1-container-left">
      <img src="/img/newlp_bg_1.webp" alt="background" class="bg-1-image-left" />
    </div>
  </div>

  <!-- 参加費用0円セクション -->
  <!-- PC版用のコンテンツコンテナ -->
  <div class="cost-section">
    <div class="hero-content naka-cost-section">
      <div v-if="windowWidth <= 1080" class="vertical-title-right">SUKISUKI LIVE STATION</div>

      <div class="cost-background">
        <div v-if="windowWidth >= 1081" class="title-bg-cost-left">
          <img src="/img/newlp_bg_dod.webp" alt="左上背景" class="title-bg-top-left-image" />
        </div>
        <div class="pig-container">
          <img src="/img/newlp_buta.webp" alt="ブタ" class="cost-pig-image" />
          <div class="pig-speech-bubble">
            <div class="speech-bubble-content">
              <div class="cost-highlight">
                <span class="highlight-text-naka">※参加費用はかかりません。</span>
              </div>
              <div class="highlight-image-container">
                <img src="/img/newlp_kyoutyou.webp" alt="強調" class="highlight-image" />
              </div>
              <div v-if="windowWidth <= 749" class="cost-description">
                <p>ご用意いただくのは、</p>
                <p>グッズ用のデザイン素材のみです。</p>
                <p>弊社のデザイナーと理想のグッズデザインを</p>
                <p>作り上げましょう。</p>
              </div>
              <div v-else class="cost-description">
                <p>ご用意いただくのは、 グッズ用のデザイン素材のみです。</p>
                <p>弊社のデザイナーと理想のグッズデザインを作り上げましょう。</p>
              </div>
            </div>
          </div>
        </div>

        <div class="right-section">
          <div class="man-container">
            <div class="man-speech-bubble">
              <div class="man-bubble-content">＼お任せください！／</div>
            </div>
            <div class="man-figure">
              <img src="/img/newlp_man2.webp" alt="man" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SUKISUKIライブステーション説明セクション -->
  <div class="sukisuki-section">
    <!-- 右上背景画像 PC版用（min-width: 1440px）-->
    <div class="sukisuki-bg-top-right-bg">
      <img src="/img/newlp_bg_2.webp" alt="右上背景" class="sukisuki-bg2-image right-bg" />
    </div>
    <div class="sukisuki-bg-top-left-bg">
      <img src="/img/newlp_bg_2.webp" alt="左上背景" class="sukisuki-bg2-image" />
    </div>

    <!-- 左下の背景画像 -->
    <!-- BG2セクション PC版用-->
    <div v-if="windowWidth >= 1081" class="bg-2-section stick-hidden">
      <div class="bg-2-container">
        <img src="/img/newlp_bg_1.webp" alt="Background 1" class="bg-1-image" />
      </div>
    </div>
    <!-- BG2セクション下 PC版用-->
    <div v-if="windowWidth >= 1081" class="bg-2-section-bottom stick-hidden">
      <div class="bg-2-container-bottom">
        <img src="/img/newlp_bg_1.webp" alt="Background 1" class="bg-1-image" />
      </div>
    </div>
    <!-- BG2セクション（PC版用） -->
    <div v-if="windowWidth >= 1081" class="bg-2-section-left stick-hidden">
      <div class="bg-2-container-left">
        <img src="/img/newlp_bg_1.webp" alt="background" class="bg-1-image-left" />
      </div>
    </div>
    <div class="sukisuki-container">
      <!-- 背景画像 PC版用（min-width: 1440px）-->
      <div v-if="windowWidth >= 1081" class="sukisuki-bg-top-left">
        <img src="/img/newlp_bg_dod.webp" alt="左上背景" class="sukisuki-bg-image" />
      </div>
      <div v-if="windowWidth >= 1081" class="sukisuki-bg-top-right">
        <img src="/img/newlp_bg_dod.webp" alt="右上背景" class="sukisuki-bg-image" />
      </div>
      <div v-if="windowWidth >= 1081" class="sukisuki-bg-bottom-left">
        <img src="/img/newlp_bg_dod.webp" alt="左下背景" class="sukisuki-bg-image" />
      </div>
      <div v-if="windowWidth >= 1081" class="sukisuki-bg-bottom-right">
        <img src="/img/newlp_bg_dod.webp" alt="右下背景" class="sukisuki-bg-image" />
      </div>
      <!-- メインタイトル -->
      <div class="sukisuki-title-section">
        <div class="sukisuki-title-bg">
          <h2 class="sukisuki-main-title">SUKISUKIらいぶすてーしょんとは？</h2>
        </div>
        <div class="sukisuki-subtitle">
          <h3 class="sukisuki-subtitle-main">SUKISUKI LIVE STATION</h3>
          <p class="sukisuki-subtitle-text">「こんなグッズ販売がしたかった」が、ここに。</p>
        </div>
      </div>

      <!-- POINT 1 -->
      <div class="point-section point-1">
        <div class="point-header">
          <span class="point-text">POINT</span>
          <span class="point-number">1</span>
        </div>
        <div class="point-content">
          <div class="point-title-container">
            <h3 class="point-title">
              いま応援してくれた“ファン”へ<br v-if="windowWidth <= 749" />すぐにお礼を
            </h3>

            <p class="point-description">
              配信中に購入者の名前(ニックネーム)が<br
                v-if="windowWidth <= 749"
              />表示され、その場でお礼が言える。
            </p>
          </div>
          <div class="horizontal-line"></div>

          <div class="point-illustration">
            <img
              v-if="windowWidth <= 749"
              src="/img/newlp_fukidashi1.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
            <img
              v-else
              src="/img/newlp_fukidashi1PC.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
          </div>
        </div>
      </div>

      <!-- POINT 2 -->
      <div class="point-section point-2">
        <div class="point-header">
          <span class="point-text">POINT</span>
          <span class="point-number">2</span>
        </div>
        <div class="point-content">
          <div class="point-title-container">
            <h3 class="point-title">
              <span class="point-title"
                >当たった瞬間、配信が沸く!<br v-if="windowWidth <= 749" />
              </span>
            </h3>
            <p class="point-description">
              くじ引き結果が表示され<br v-if="windowWidth <= 749" />ファンも自分も盛り上がる。
            </p>
          </div>
          <div class="horizontal-line"></div>

          <div class="point-illustration">
            <img
              v-if="windowWidth <= 749"
              src="/img/newlp_fukidashi2.webp"
              alt="ポイント説明"
              class="point-illustration-image point2-margin"
            />
            <img
              v-else
              src="/img/newlp_fukidashi2PC.webp"
              alt="ポイント説明"
              class="point-illustration-image point2-margin"
            />
          </div>
        </div>
      </div>

      <!-- POINT 3 -->
      <div class="point-section point-3">
        <div class="point-header">
          <span class="point-text">POINT</span>
          <span class="point-number">3</span>
        </div>
        <div class="point-content">
          <div class="point-title-container">
            <h3 class="point-title">
              <span class="point-title"
                >"配信ならでは"の販売体験<br v-if="windowWidth <= 749" />
              </span>
            </h3>
            <p class="point-description">
              ライブ感・盛り上がり・演出付きの「グッズ<br
                v-if="windowWidth <= 749"
              />販売イベント」に。
            </p>
          </div>
          <div class="horizontal-line"></div>

          <div class="point-illustration">
            <img
              v-if="windowWidth <= 749"
              src="/img/newlp_fukidashi3.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
            <img
              v-else
              src="/img/newlp_fukidashi3PC.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
          </div>
        </div>
      </div>

      <!-- POINT 4 -->
      <div class="point-section point-4">
        <div class="point-header">
          <span class="point-text">POINT</span>
          <span class="point-number">4</span>
        </div>
        <div class="point-content">
          <div class="point-title-container">
            <h3 class="point-title">
              <span class="point-title"
                >面倒なことはすべておまかせ!<br v-if="windowWidth <= 749" />
              </span>
            </h3>
            <p class="point-description">
              グッズのデザインから製造、<br v-if="windowWidth <= 749" />発送まで全て代行。<br
                v-if="windowWidth <= 749"
              />
              配信販売のみに集中したまま、<br />プロ品質のグッズ販売が叶います。
            </p>
          </div>
          <div class="horizontal-line"></div>

          <div class="point-illustration">
            <img
              v-if="windowWidth <= 749"
              src="/img/newlp_fukidashi4.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
            <img
              v-else
              src="/img/newlp_fukidashi4PC.webp"
              alt="ポイント説明"
              class="point-illustration-image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- アクションセクション -->
  <div class="action-section action-section-margin action-section-background">
    <div class="action-container">
      <!-- PDFで資料を見る -->
      <!-- PDFで資料を見る -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv1.webp" alt="PDF資料" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼詳しい情報はこちらから！／</h3>
          <button v-if="documentId" class="action-button pdf-button" @click="onPdf">
            PDFで資料を見る
            <span class="arrow">▶</span>
          </button>
          <button v-else class="action-button pdf-button" @click="openModal">
            資料を見る / 参加申し込み
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>

      <!-- LINEで相談する -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv2.webp" alt="LINE相談" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼お気軽にご相談ください！／</h3>
          <button class="action-button line-button" @click="onLine">
            LINEで相談する
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>

      <!-- オンライン説明を予約する -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv3.webp" alt="オンライン説明" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼直接説明を受けたい方へ！／</h3>
          <button class="action-button online-button" @click="onReserve">
            オンライン説明を予約する
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ライブ配信風UIセクション -->
  <div class="live-stream-section stick-hidden">
    <div v-if="windowWidth >= 1081" class="bg-2-stream-bottom">
      <div class="bg-2-container-bottom">
        <img src="/img/newlp_bg_1.webp" alt="Background 1" class="bg-1-image" />
      </div>
    </div>
    <div v-if="windowWidth >= 1081" class="bg-2-stream-left stick-hidden">
      <div class="bg-2-container-left">
        <img src="/img/newlp_bg_1.webp" alt="background" class="bg-1-image-left" />
      </div>
    </div>
    <div class="live-container">
      <button class="actual-screen-button">実際の画面</button>
      <div class="video-feed">
        <img
          :src="uiImages[currentUISlide].src"
          :alt="uiImages[currentUISlide].alt"
          class="ui-image"
        />
      </div>
      <div class="pagination-dots">
        <div
          v-for="(_, index) in uiImages"
          :key="index"
          class="dot"
          :class="{ active: currentUISlide === index }"
          @click="currentUISlide = index"
        ></div>
      </div>
    </div>
  </div>

  <!-- 紹介動画セクション -->
  <div class="video-section-wrapper stick-hidden">
    <div v-if="windowWidth >= 1081" class="bg-2-video-bottom">
      <div class="bg-2-container-bottom">
        <img src="/img/newlp_bg_1.webp" alt="Background 1" class="bg-1-image" />
      </div>
    </div>
    <div class="video-section">
      <div class="video-container">
        <button class="video-title-button">紹介動画</button>
        <div class="video-wrapper-container">
          <div class="video-wrapper">
            <iframe
              id="player"
              src="https://www.youtube.com/embed/vwuYS-hXT9c?rel=0&modestbranding=1&showinfo=0&enablejsapi=1"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 実施事例セクション -->
  <div class="example-section-wrapper">
    <div v-if="windowWidth >= 1081" class="bg-2-example-left stick-hidden">
      <div class="bg-2-container-left">
        <img src="/img/newlp_bg_1.webp" alt="background" class="bg-1-image-left" />
      </div>
    </div>
    <div class="example-section">
      <div class="example-container">
        <button class="example-title-button">実施事例</button>
        <div class="example-feed">
          <div class="example-slider-container">
            <div
              class="example-slider-wrapper"
              :style="{ transform: `translateX(-${currentExampleSlide * 100}%)` }"
            >
              <div class="example-slide" v-for="(image, index) in exampleImages" :key="index">
                <img :src="image.src" :alt="image.alt" class="example-image" />
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-dots">
          <div
            v-for="(_, index) in exampleImages"
            :key="index"
            class="dot"
            :class="{ active: currentExampleSlide === index }"
            @click="currentExampleSlide = index"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- よくある質問セクション -->
  <div class="QA-section">
    <button class="qa-tab-button">よくある質問</button>
    <div class="QA-content">
      <div class="QA-item">
        <div class="qa-question-row">
          <div class="qa-avatar">
            <img src="/img/newlp_faq1.webp" alt="質問者" class="qa-avatar-image" />
          </div>
          <span class="qa-question-balloon">
            <span class="qa-q">Q.</span>
            <span class="qa-text">参加するのに費用がかかりますか？</span>
          </span>
        </div>
        <div class="qa-answer-row">
          <span class="qa-answer-balloon">
            <span class="qa-a">A.</span>
            <span class="qa-text">参加費用は無料です。</span>
          </span>
          <div class="qa-avatar">
            <img src="/img/newlp_faq2.webp" alt="回答者" class="qa-avatar-image" />
          </div>
        </div>
      </div>
      <div class="QA-item">
        <div class="qa-question-row">
          <div class="qa-avatar">
            <img src="/img/newlp_faq1.webp" alt="質問者" class="qa-avatar-image" />
          </div>
          <span class="qa-question-balloon">
            <span class="qa-q">Q.</span>
            <span class="qa-text">グッズデザインや発送は代行してくれますか？</span>
          </span>
        </div>
        <div class="qa-answer-row">
          <span class="qa-answer-balloon">
            <span class="qa-a">A.</span>
            <span class="qa-text">グッズのデザインから製造、発送まで全て代行いたします。</span>
          </span>
          <div class="qa-avatar">
            <img src="/img/newlp_faq2.webp" alt="回答者" class="qa-avatar-image" />
          </div>
        </div>
      </div>
      <div class="QA-item">
        <div class="qa-question-row">
          <div class="qa-avatar">
            <img src="/img/newlp_faq1.webp" alt="質問者" class="qa-avatar-image" />
          </div>
          <span class="qa-question-balloon">
            <span class="qa-q">Q.</span>
            <span class="qa-text">視聴者は配信時間外でも購入できますか？</span>
          </span>
        </div>
        <div class="qa-answer-row">
          <span class="qa-answer-balloon">
            <span class="qa-a">A.</span>
            <span class="qa-text">ご購入は配信時間外でも可能です。</span>
          </span>
          <div class="qa-avatar">
            <img src="/img/newlp_faq2.webp" alt="回答者" class="qa-avatar-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="company">
    <button class="company-title-button">運営会社</button>
    <div class="company-info">
      <div class="company-info-item">
        <div class="company-info-label">会社名</div>
        <div class="company-info-content">株式会社ランダムファクトリー</div>
      </div>
      <div class="company-info-item">
        <div class="company-info-label">本社</div>
        <div class="company-info-content">
          〒150-0043<br />
          東京都渋谷区道玄坂1丁目10番8号<br />
          渋谷道玄坂東急ビル2F-C
        </div>
      </div>
      <div class="company-info-item">
        <div class="company-info-label">電話番号</div>
        <div class="company-info-content">03-6774-7991 (代表)</div>
      </div>
      <div class="company-info-item">
        <div class="company-info-label">メールアドレス</div>
        <div class="company-info-content">info@randamfactory.co.jp</div>
      </div>
      <div class="company-info-item">
        <div class="company-info-label">役員</div>
        <div class="company-info-content">
          代表取締役CEO 伊奈守道<br />
          取締役CTO 宮川健吾
        </div>
      </div>
      <div class="company-info-item">
        <div class="company-info-label">事業内容</div>
        <div class="company-info-content">
          SukiSukiらいぶすてーしょんの運営、<br />
          ライブコマース支援事業
        </div>
      </div>
    </div>
  </div>

  <!-- アクションセクション -->
  <div class="action-section action-section-white">
    <div class="action-container">
      <!-- PDFで資料を見る -->
      <!-- PDFで資料を見る -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv1.webp" alt="PDF資料" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼詳しい情報はこちらから！／</h3>
          <button v-if="documentId" class="action-button pdf-button" @click="onPdf">
            PDFで資料を見る
            <span class="arrow">▶</span>
          </button>
          <button v-else class="action-button pdf-button" @click="openModal">
            資料を見る / 参加申し込み
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>

      <!-- LINEで相談する -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv2.webp" alt="LINE相談" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼お気軽にご相談ください！／</h3>
          <button class="action-button line-button" @click="onLine">
            LINEで相談する
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>

      <!-- オンライン説明を予約する -->
      <div class="action-item">
        <div class="action-icon">
          <img src="/img/newlp_cv3.webp" alt="オンライン説明" class="action-icon-image" />
        </div>
        <div class="action-content">
          <h3 class="action-title">＼直接説明を受けたい方へ！／</h3>
          <button class="action-button online-button" @click="onReserve">
            オンライン説明を予約する
            <span class="arrow">▶</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 最新情報セクション -->
  <div class="latest-info-section">
    <p class="latest-info-title">最新情報をチェック！</p>
    <div class="info-cards">
      <!-- 公式サイト -->
      <div class="info-card" @click="goToTopPage">
        <div class="info-card-left">
          <img
            src="/img/newlp_sukisukilogoclean.webp"
            alt="SUKISUKI LIVE STATION"
            class="info-logo-sukisuki"
          />
        </div>
        <div class="info-card-right">
          <div class="info-label">公式サイト</div>
          <div class="info-url-top">https://sukisuki.live/</div>
        </div>
      </div>

      <!-- X (旧Twitter) -->
      <div class="info-card" @click="goToXProfile">
        <div class="info-card-left">
          <img src="/img/newlp_xicon.webp" alt="X (旧Twitter)" class="info-logo-x" />
        </div>
        <div class="info-card-right">
          <div class="info-label">X (旧Twitter)</div>
          <div class="info-url-bottom">@sukisukils</div>
        </div>
      </div>
    </div>
  </div>

  <!-- モーダル -->
  <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">お問い合わせ/資料ダウンロード</h2>
        <button class="modal-close" @click="closeModal">×</button>
      </div>

      <form @submit.prevent="submitForm" class="modal-form">
        <div class="form-group">
          <label for="name" class="form-label"
            >お名前（活動名）<span class="required">*</span></label
          >
          <input type="text" id="name" v-model="formData.name" class="form-input" required />
        </div>

        <div class="form-group">
          <label for="company" class="form-label">会社名</label>
          <input type="text" id="company" v-model="formData.company" class="form-input" />
        </div>

        <div class="form-group">
          <label for="email" class="form-label"
            >メールアドレス<span class="required">*</span></label
          >
          <input type="email" id="email" v-model="formData.email" class="form-input" required />
        </div>

        <div class="form-group">
          <label for="twitter" class="form-label">X (Twitter) アカウント名</label>
          <input
            type="text"
            id="twitter"
            v-model="formData.twitter"
            class="form-input"
            placeholder="@username"
          />
        </div>

        <div class="form-group">
          <label for="referralCode" class="form-label">紹介コード</label>
          <input type="text" id="referralCode" v-model="formData.referralCode" class="form-input" />
        </div>

        <div class="form-group">
          <label class="form-label">お問い合わせ内容<span class="required">*</span></label>
          <div class="radio-group">
            <label class="radio-item">
              <input
                type="radio"
                v-model="formData.inquiryType"
                value="参加したい"
                class="radio-input"
              />
              <span class="radio-label">参加したい</span>
            </label>
            <label class="radio-item">
              <input
                type="radio"
                v-model="formData.inquiryType"
                value="詳細を聞いてみたい"
                class="radio-input"
              />
              <span class="radio-label">詳細を聞いてみたい</span>
            </label>
            <label class="radio-item">
              <input
                type="radio"
                v-model="formData.inquiryType"
                value="まずは資料を見たい"
                class="radio-input"
              />
              <span class="radio-label">まずは資料を見たい</span>
            </label>
            <label class="radio-item">
              <input
                type="radio"
                v-model="formData.inquiryType"
                value="その他"
                class="radio-input"
              />
              <span class="radio-label">その他</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="message" class="form-label">ご質問・お問い合わせ</label>
          <textarea
            id="message"
            v-model="formData.message"
            class="form-textarea"
            rows="4"
            placeholder="ご質問やお問い合わせ内容をご記入ください"
          ></textarea>
        </div>

        <div class="form-actions">
          <div v-if="isFormSubmitted" class="success-message">
            <p>お問い合わせありがとうございます。</p>
            <p>資料は以下よりダウンロードいただけます。</p>
            <p>3営業日以内に、担当よりご連絡いたします。</p>
            <button type="button" class="btn-download" @click="onPdfIppan">
              資料をダウンロード
            </button>
            <div style="margin-top: 12px"></div>
            <button type="button" class="btn-cancel" @click="closeModal">閉じる</button>
          </div>
          <template v-else>
            <button type="submit" class="btn-submit" :disabled="isLoading">
              <span v-if="isLoading">送信中...</span>
              <span v-else>資料をダウンロードして問い合わせる</span>
            </button>
            <button type="button" class="btn-cancel" @click="closeModal" :disabled="isLoading">
              キャンセル
            </button>
          </template>
        </div>
      </form>
    </div>
  </div>

  <!-- Jicoo予約フォームモーダル -->
  <div v-if="showScheduleForm" class="schedule-modal-overlay" @click="closeScheduleModal">
    <div class="schedule-modal" @click.stop>
      <div class="schedule-modal-header">
        <h3>オンライン説明会予約</h3>
        <button class="schedule-modal-close" @click="closeScheduleModal">&times;</button>
      </div>
      <div class="schedule-modal-content">
        <!-- Jicoo widget begin -->
        <div
          class="jicoo-widget"
          data-url="https://www.jicoo.com/event_types/x38_c5NfG6cw/widget"
          style="
            min-width: 320px;
            height: 720px;
            border: 1px solid #e4e4e4;
            box-sizing: content-box;
          "
        ></div>
        <!-- Jicoo widget end -->
      </div>
    </div>
  </div>
</template>

<script setup>
// import DocumentInviteButton from "@/components/molecules/DocumentInviteButton.vue";
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useRouter } from "vue-router";
import { useHead } from "@vueuse/head";

const router = useRouter();

const currentSlide = ref(0);
const currentExampleSlide = ref(0);
const currentUISlide = ref(0);
const images = [
  { src: "/img/newlp_ui.webp", alt: "実際の画面イメージ1" },
  { src: "/img/newlp_ui2.webp", alt: "実際の画面イメージ2" },
  { src: "/img/newlp_ui3.webp", alt: "実際の画面イメージ3" },
];

const uiImages = [
  { src: "/img/newlp_ui.webp", alt: "実際の画面イメージ1" },
  { src: "/img/newlp_ui2.webp", alt: "実際の画面イメージ2" },
  { src: "/img/newlp_ui3.webp", alt: "実際の画面イメージ3" },
];

const exampleImages = [
  { src: "/img/newlp_example1.webp", alt: "実施事例1" },
  { src: "/img/newlp_example2.webp", alt: "実施事例2" },
  { src: "/img/newlp_example3.webp", alt: "実施事例3" },
];

let slideInterval;
let exampleSlideInterval;
let uiSlideInterval;

const startSlideShow = () => {
  slideInterval = setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % images.length;
  }, 5000);
};

const startExampleSlideShow = () => {
  exampleSlideInterval = setInterval(() => {
    currentExampleSlide.value = (currentExampleSlide.value + 1) % exampleImages.length;
  }, 5000);
};

const startUISlideShow = () => {
  uiSlideInterval = setInterval(() => {
    currentUISlide.value = (currentUISlide.value + 1) % uiImages.length;
  }, 5000);
};

const onLine = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "line_click",
    event_category: "documentinvite",
    event_label: "clickLine",
  });
  window.open("https://lin.ee/epMhiCc", "_blank");
};

const goToTopPage = () => {
  router.push("/");
};

const goToXProfile = () => {
  window.open("https://x.com/sukisukils", "_blank");
};

// モーダルを開く関数
const openModal = () => {
  isModalOpen.value = true;
  // 背景のスクロールを禁止
  document.body.style.overflow = "hidden";
};

// モーダルを閉じる関数
const closeModal = () => {
  isModalOpen.value = false;
  // 背景のスクロールを復元
  document.body.style.overflow = "";
  // フォームをリセット
  formData.value = {
    name: "",
    company: "",
    email: "",
    twitter: "",
    referralCode: "",
    inquiryType: "",
    message: "",
  };
  // 送信完了状態をリセット
  isFormSubmitted.value = false;
};

// フォーム送信処理
const submitForm = async () => {
  try {
    // バリデーション
    if (!formData.value.name || !formData.value.email || !formData.value.inquiryType) {
      alert("お名前、メールアドレス、お問い合わせ内容は必須項目です。");
      return;
    }

    // ローディング開始
    isLoading.value = true;

    // Firebase Functionsを呼び出してフォームデータを送信
    const functions = getFunctions();
    functions.region = "asia-northeast1";
    const commonContactMail = httpsCallable(functions, "Vendor_contactMail");

    const result = await commonContactMail({
      name: formData.value.name,
      company: formData.value.company,
      email: formData.value.email,
      twitter: formData.value.twitter,
      referralCode: formData.value.referralCode,
      inquiryType: formData.value.inquiryType,
      details: formData.value.message,
      source: source.value || "DocumentInvite",
    });

    console.log("フォーム送信結果:", result);

    // 成功時の処理
    isFormSubmitted.value = true;
  } catch (error) {
    console.error("フォーム送信エラー:", error);
    alert("送信に失敗しました。もう一度お試しください。");
  } finally {
    // ローディング終了
    isLoading.value = false;
  }
};

onMounted(() => {
  if (documentId) {
    callFunction(documentId);
  } else {
    // console.log("URLにIDが指定されていないため、処理をスキップします");
    // IDがない場合はデフォルトでTawk.toを初期化
    // initializeTawkTo();
  }

  // URLパラメータから広告元を取得
  const urlParams = new URLSearchParams(window.location.search);
  const sourceParam = urlParams.get("source");
  const utmSourceParam = urlParams.get("utm_source");
  const utmMediumParam = urlParams.get("utm_medium");
  const utmCampaignParam = urlParams.get("utm_campaign");

  if (sourceParam) {
    source.value = sourceParam;
  } else if (utmSourceParam) {
    source.value = utmSourceParam;
  }

  if (utmMediumParam) {
    medium.value = utmMediumParam;
  }

  if (utmCampaignParam) {
    campaign.value = utmCampaignParam;
  }

  // Google AnalyticsにUTMパラメータを送信
  if (window.gtag) {
    window.gtag("config", "GA_MEASUREMENT_ID", {
      custom_map: {
        custom_parameter_1: "utm_source",
        custom_parameter_2: "utm_medium",
        custom_parameter_3: "utm_campaign",
      },
    });

    window.gtag("event", "page_view", {
      utm_source: source.value,
      utm_medium: medium.value,
      utm_campaign: campaign.value,
    });
  }

  startSlideShow();
  startExampleSlideShow();
  startUISlideShow();
  // YouTube APIスクリプトを動的に読み込む
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // グローバル関数として設定
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
});

onUnmounted(() => {
  if (slideInterval) {
    clearInterval(slideInterval);
  }
  if (exampleSlideInterval) {
    clearInterval(exampleSlideInterval);
  }
  if (uiSlideInterval) {
    clearInterval(uiSlideInterval);
  }
  // コンポーネントアンマウント時にスクロールを復元
  document.body.style.overflow = "";
  // Jicooウィジェットをクリーンアップ
  cleanupJicooWidget();
});
const showScheduleForm = ref(false);

// Jicooウィジェット要素を再初期化する関数
const recreateJicooWidgetElement = () => {
  const widgetElement = document.querySelector(".jicoo-widget");

  if (widgetElement) {
    // 要素のサイズを保存
    const rect = widgetElement.getBoundingClientRect();
    const styles = window.getComputedStyle(widgetElement);

    // 一時的なプレースホルダー要素を作成（同じサイズ）
    const placeholder = document.createElement("div");
    placeholder.style.cssText = `
      width: ${rect.width}px;
      height: ${rect.height}px;
      border: ${styles.border};
      box-sizing: content-box;
      background-color: #f9f9f9;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    placeholder.innerHTML = '<div style="color: #666; font-size: 14px;">読み込み中...</div>';

    // 既存要素をプレースホルダーで置き換え
    widgetElement.parentNode.replaceChild(placeholder, widgetElement);

    // 新しいウィジェット要素を作成
    const newWidgetElement = document.createElement("div");
    newWidgetElement.className = "jicoo-widget";
    newWidgetElement.setAttribute(
      "data-url",
      "https://www.jicoo.com/event_types/x38_c5NfG6cw/widget"
    );
    newWidgetElement.style.cssText = `
      min-width: 320px;
      height: 720px;
      border: 1px solid #e4e4e4;
      box-sizing: content-box;
    `;

    // プレースホルダーを新しいウィジェットで置き換え
    placeholder.parentNode.replaceChild(newWidgetElement, placeholder);
  }
};
// PDFファイルのURL
const pdfUrl = ref(
  "https://storage.googleapis.com/rf-prd-sukisuki-ls.appspot.com/live_station_images_common/%E3%83%AA%E3%82%A2%E3%83%AB%E3%82%BF%E3%82%A4%E3%83%A0%E3%81%8F%E3%81%97%E3%82%99%E5%BC%95%E3%81%8D%E3%80%8CSukiSuki%E3%82%89%E3%81%84%E3%81%B5%E3%82%99%E3%81%99%E3%81%A6%E3%83%BC%E3%81%97%E3%82%87%E3%82%93%E3%80%8D%E3%81%93%E3%82%99%E6%8F%90%E6%A1%88%E8%B3%87%E6%96%99_202506%E7%89%88.pdf"
);

const onPdf = () => {
  // GTMを使用したイベント計測
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pdf_view",
    event_category: "documentinvite",
    event_label: "viewPDFdocument",
  });
  window.open(pdfUrl.value, "_blank");
};

// フォームからの資料ダウンロード用
const onPdfIppan = () => {
  // GTMを使用したイベント計測
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pdf_download",
    event_category: "documentinvite",
    event_label: "downloadPDFfromForm",
  });
  window.open(
    "https://storage.googleapis.com/rf-prd-sukisuki-ls.appspot.com/live_station_images_common/%E3%83%AA%E3%82%A2%E3%83%AB%E3%82%BF%E3%82%A4%E3%83%A0%E3%81%8F%E3%81%97%E3%82%99%E5%BC%95%E3%81%8D%E3%80%8CSukiSuki%E3%82%89%E3%81%84%E3%81%B5%E3%82%99%E3%81%99%E3%81%A6%E3%83%BC%E3%81%97%E3%82%87%E3%82%93%E3%80%8D%E8%B3%87%E6%96%99_202510%E7%89%88.pdf",
    "_blank"
  );
};

// オンライン説明予約ボタンのクリックハンドラーを追加
const onReserve = () => {
  // GTMを使用したイベント計測
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "reserve_click",
    event_category: "documentinvite",
    event_label: "clickReserve",
  });

  // Jicooスクリプトを読み込み、予約フォームを表示
  loadJicooScript();

  // モーダルを表示
  showScheduleForm.value = true;

  // Vue.jsのnextTickを使用してDOM更新を待つ
  nextTick(() => {
    // ウィジェット要素を完全に再作成
    recreateJicooWidgetElement();
  });
};

// 予約フォームモーダルを閉じる
const closeScheduleModal = () => {
  showScheduleForm.value = false;
  // ウィジェットをクリーンアップ
  cleanupJicooWidget();
};

// Jicooウィジェットをクリーンアップする関数
const cleanupJicooWidget = () => {
  const widgetElement = document.querySelector(".jicoo-widget");
  if (widgetElement) {
    // 要素の内容をクリア
    widgetElement.innerHTML = "";
  }
};

// Jicooウィジェットのスクリプトを動的に読み込む
const loadJicooScript = () => {
  // 既にスクリプトが読み込まれているかチェック
  const existingScript = document.querySelector(
    'script[src="https://www.jicoo.com/widget/event_type.js"]'
  );

  if (existingScript) {
    // 既存のスクリプトを削除して再読み込み
    existingScript.remove();
  }

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://www.jicoo.com/widget/event_type.js";
  script.async = true;
  document.head.appendChild(script);
};

// ユーザー名を管理
const userName = ref("");
const result = ref(null);
const isFetchingName = ref(false);

// URLからクエリパラメータを取得する関数
const getQueryParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

// Firebase Functionsを呼び出す関数
const callFunction = async (documentId) => {
  if (isFetchingName.value) return;

  isFetchingName.value = true;
  try {
    const functions = getFunctions(undefined, "asia-northeast1");
    const getDocument = httpsCallable(functions, "sendToEngageWithRate");

    const response = await getDocument({ id: documentId });

    // 結果から名前を取得
    if (response.data && response.data.name) {
      userName.value = response.data.name;
      // console.log("ユーザー名を設定しました:", userName.value);
      // 名前が取得された後にTawk.toを再初期化
      // initializeTawkTo();
    } else {
      userName.value = null;
      // console.warn("名前の取得に失敗しました。");
    }

    // console.log("Firebase Functions レスポンス:", response.data);
  } catch (err) {
    // console.error("Firebase Functions エラー:", err);
    result.value = { error: err.message };
    userName.value = null;
  } finally {
    isFetchingName.value = false;
  }
};

// URLからIDを取得
const documentId = getQueryParam("id");

// モーダルの状態管理
const isModalOpen = ref(false);

// フォームの状態管理
const formData = ref({
  name: "",
  company: "",
  email: "",
  twitter: "",
  referralCode: "",
  inquiryType: "",
  message: "",
});

// フォーム送信完了状態
const isFormSubmitted = ref(false);

// ローディング状態
const isLoading = ref(false);

// 広告元の状態管理
const source = ref("");
const medium = ref("");
const campaign = ref("");

// YouTubeプレーヤーの状態を監視するための変数
const player = ref(null);
const isHalfwayPlayed = ref(false);

// YouTube APIが読み込まれたときに呼び出される関数
const onYouTubeIframeAPIReady = () => {
  player.value = new window.YT.Player("player", {
    events: {
      onStateChange: onPlayerStateChange,
      onReady: onPlayerReady,
    },
  });
};

const onPlayerReady = () => {
  // console.log("YouTubeプレーヤーの準備が完了しました");
};

// プレーヤーの状態が変更されたときに呼び出される関数
const onPlayerStateChange = (event) => {
  if (event.data === window.YT.PlayerState.PLAYING && !isHalfwayPlayed.value) {
    const duration = player.value.getDuration();
    const interval = setInterval(() => {
      const currentTime = player.value.getCurrentTime();
      const progress = (currentTime / duration) * 100;

      if (progress >= 50 && !isHalfwayPlayed.value) {
        // console.log("再生完了（50%以上）");
        isHalfwayPlayed.value = true;
        clearInterval(interval);

        // Firebase Functionsを呼び出す
        if (documentId) {
          const functions = getFunctions(undefined, "asia-northeast1");
          const sendToEngageForVideo = httpsCallable(functions, "sendToEngageForVideo");
          sendToEngageForVideo({ id: documentId })
            .then((response) => {
              console.log("動画視聴完了の通知を送信しました:", response.data);
            })
            .catch((error) => {
              console.error("動画視聴完了の通知に失敗しました:", error);
            });
        }
      }
    }, 1000);
  }
};

// windowWidthの管理
const windowWidth = ref(
  typeof document !== "undefined"
    ? document.documentElement.clientWidth || window.innerWidth
    : window.innerWidth
);

const updateWindowWidth = () => {
  // console.log("Before update - windowWidth:", windowWidth.value);
  // console.log("window.innerWidth:", window.innerWidth);
  // 開発者ツールのレスポンシブモードに対応
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  // console.log("viewportWidth:", viewportWidth);
  windowWidth.value = viewportWidth;
  // console.log("After update - windowWidth:", windowWidth.value);
};

onMounted(() => {
  // console.log("Mounted - Initial windowWidth:", windowWidth.value);
  // console.log("Mounted - window.innerWidth:", window.innerWidth);
  updateWindowWidth();
  window.addEventListener("resize", updateWindowWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowWidth);
});

useHead({
  title: "参加者募集中 | SukiSukiらいぶすてーしょん",
  meta: [
    {
      name: "description",
      content:
        "「リアルタイムくじ引き」のSukiSukiらいぶすてーしょんでは、リアルタイムくじ引きの参加者を募集しています。グッズの企画・制作から販売・発送まで、すべて当社が対応いたします。初期費用や参加費は一切かかりません。",
    },
    {
      property: "og:title",
      content: "リアルタイムくじ引き参加者募集中 | SukiSukiらいぶすてーしょん",
    },
    {
      property: "og:description",
      content:
        "「リアルタイムくじ引き」のSukiSukiらいぶすてーしょんでは、参加者を募集しています。グッズの企画・制作から販売・発送まで、すべて当社が対応いたします。初期費用や参加費は一切かかりません。",
    },
    {
      property: "og:type",
      content: "website",
    },
  ],
});
</script>

<style scoped>
/* ===== 共通スタイル（色・フォント指定） ===== */

.document-invite {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* ページ全体のマージンをリセット */
:global(body) {
  margin: 0 !important;
  padding: 0 !important;
}

:global(html) {
  margin: 0 !important;
  padding: 0 !important;
}

/* このページのみでmainクラスのmin-heightを無効化 */
:global(.main) {
  min-height: auto !important;
}

/* アクションセクション */
.action-section {
  background: #ffe3f2;
  position: relative;
  overflow: hidden;
}

.action-section-white {
  background: #fff;
}

/* 最新情報セクション */
.latest-info-section {
  background: #ffe3f2;
  text-align: center;
  margin-bottom: 0;
}

.latest-info-title {
  font-size: 18px;
  font-weight: bold;
  color: #a544af;
}

/* .info-cards {
  max-width: 500px;
  margin: 0 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
} */

.info-card {
  background: #fff;
  border: 2px solid #982da6;
  border-radius: 40px;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  position: relative;
  height: 80px;
  cursor: pointer;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(152, 45, 166, 0.2);
}

.info-card-left {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.info-logo-sukisuki {
  width: 140px;
  height: auto;
  object-fit: contain;
}

.info-logo-x {
  width: 140px;
  height: 35px;
  object-fit: contain;
}

.info-card-right {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.info-label {
  color: #982da6;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.25rem;
  text-align: center;
}

.info-url {
  color: #333;
  font-size: 0.9rem;
  font-weight: normal;
}

.info-url-top {
  color: #333;
  font-size: 0.9rem;
  font-weight: normal;
  padding-top: 5px;
}

.info-url-bottom {
  color: #333;
  font-size: 0.9rem;
  font-weight: normal;
  text-align: center;
  padding-top: 5px;
}
/* .action-section-naka {
  position: relative;
  overflow: hidden;
  margin-top: -70px;
} */

.background-image {
  position: absolute;
  left: -30px;
  top: 65%;
  transform: translateY(-50%);
  z-index: 3;
}

.background-image img {
  max-width: 75px;
  height: auto;
}

.line-button:hover {
  background: #e6d700;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 215, 0, 0.5);
}

/* .action-item {
  display: flex;
  align-items: flex-end;
  gap: 0.2rem;
  margin-bottom: 0rem;
  padding: 0.2rem;
  border-radius: 15px;
}

.action-item:last-child {
  margin-bottom: 0;
}

.action-icon {
  flex-shrink: 0;
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
}

.action-icon-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 70px;
  max-height: 70px;
}

.action-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
}

.action-title {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  line-height: 1.3;
}

.action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 25px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  min-width: 220px;
  width: 100%;
  max-width: 280px;
}

.pdf-button {
  background: #d63384;
  color: #fff;
  border: 2px solid #982da6;
  box-shadow: 0 2px 4px rgba(214, 51, 132, 0.3);
}

.pdf-button:hover {
  background: #b02a5b;
  transform: translateY(-1px);
}

.line-button {
  background: #ffef00;
  color: #982da6;
  border: 2px solid #da3990;
  box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
  cursor: pointer;
}

.line-button .arrow {
  color: #982da6;
}

.line-button:hover {
  background: #ffef00;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 215, 0, 0.5);
}

.online-button {
  background: #982da6;
  color: #fff;
  border: 2px solid #da3990;
  box-shadow: 0 2px 4px rgba(152, 45, 166, 0.3);
}

.online-button:hover {
  background: #b02a5b;
  transform: translateY(-1px);
} */

.arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.action-button:hover .arrow {
  transform: translateX(2px);
}

.action-footer {
  background-color: #ffe3f2;
}

.footer-logo {
  color: #f8c1de;
}

/* ===== モバイル専用スタイル（max-width: 767px） ===== */
@media (max-width: 1080px) {
  /* アクションセクション */
  .action-section {
    padding: 1.5rem 1rem;
  }

  .action-section-naka {
    padding: 1.5rem 1rem;
  }

  .action-container {
    padding: 0.5rem;
    border-radius: 15px;
  }
  .action-container-naka {
    padding: 0.5rem;
    border-radius: 15px;
  }

  .action-container {
    max-width: 800px;
    margin: 0 auto;
    background: #f0acc4;
    border: 3px solid #982da6;
    border-radius: 20px;
    position: relative;
    z-index: 2;
    box-shadow: 8px 8px 0 #da3990;
  }

  .action-container-naka {
    max-width: 800px;
    margin: 0 auto;
    background: #f0acc4;
    border: 3px solid #982da6;
    border-radius: 20px;
    position: relative;
    z-index: 2;
    box-shadow: 8px 8px 0 #da3990;
  }

  .action-item {
    flex-direction: row;
    text-align: left;
    gap: 0.5rem;
    padding: 1rem;
  }

  .action-icon {
    width: 80px;
    height: 80px;
    margin-top: 0.3rem;
  }

  .action-icon-image {
    max-width: 80px;
    max-height: 80px;
  }

  .action-title {
    font-size: 12px;
    margin-bottom: 0;
  }

  .action-button {
    padding: 1rem 1.2rem;
    font-size: 12px;
  }

  .action-item {
    display: flex;
    align-items: flex-end;
    gap: 0.2rem;
    margin-bottom: 0rem;
    padding: 0.2rem;
    border-radius: 15px;
  }

  .action-item:last-child {
    margin-bottom: 0;
  }

  .action-icon {
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
  }

  .action-icon-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-width: 70px;
    max-height: 70px;
  }

  .action-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 1rem;
  }

  .action-title {
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    margin: 0;
    line-height: 1.3;
  }

  .action-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 25px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    min-width: 220px;
    width: 100%;
    max-width: 280px;
  }

  .pdf-button {
    background: #d63384;
    color: #fff;
    border: 2px solid #982da6;
    box-shadow: 0 2px 4px rgba(214, 51, 132, 0.3);
  }

  .pdf-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .line-button {
    background: #ffef00;
    color: #982da6;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
  }

  .line-button .arrow {
    color: #982da6;
  }

  .line-button:hover {
    background: #ffef00;
    transform: translateY(-1px);
  }

  .online-button {
    background: #982da6;
    color: #fff;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(152, 45, 166, 0.3);
  }

  .online-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .action-footer {
    text-align: center;
    margin-top: -0.85rem;
    padding: 0 0 0.7rem 0;
    position: relative;
    z-index: 3;
    width: 100%;
    display: block;
  }

  .moyamoya-left-icon,
  .moyamoya-right-icon {
    position: absolute;
    height: auto;
    z-index: 10;
    width: 40px;
    top: 50%;
    transform: translateY(-50%);
  }

  .moyamoya-left-icon {
    left: 3%;
  }

  .hero-title-container {
    position: relative;
    z-index: 3;
    margin: -1rem 0 2rem 0;
  }

  .title-background {
    position: absolute;
    top: -15px;
    right: -5px;
    z-index: 1;
    width: 110px;
    height: 110px;
  }

  .title-bg-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.8;
  }

  .title-bg-top-left {
    position: absolute;
    top: -15px;
    left: -20px;
    z-index: 1;
    width: 110px;
    height: 110px;
  }

  .title-bg-top-left-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.7;
  }

  .title-logo {
    position: relative;
    z-index: 2;
    max-width: 400px;
    height: auto;
    width: 100%;
  }
  @media (min-width: 600px) {
    .title-logo {
      max-width: 90%;
    }
    .main-visual-image {
      max-width: 100% !important;
    }
    .hero-messages {
      bottom: 3rem !important;
    }
    .hero-messages-part2 {
      bottom: 1.7rem !important;
    }
    .hero-message-sub {
      margin-top: -40px !important;
    }
    .action-icon-image {
      margin-left: 100px;
    }
  }

  .main-visual-bg-center-left {
    position: absolute;
    bottom: 50%;
    left: 15%;
    transform: translateY(50%);
    z-index: -1;
    width: 110px;
    height: 110px;
  }

  .main-visual-bg-center-right {
    position: absolute;
    bottom: 40%;
    right: 10%;
    transform: translateY(50%);
    z-index: -1;
    width: 110px;
    height: 110px;
  }

  .hero-main-visual {
    position: relative;
    z-index: 1;
    margin: -3.5rem 0 1rem 0;
    display: flex;
    justify-content: center;
  }

  .main-visual-bg-left {
    position: absolute;
    bottom: 0%;
    left: -15px;
    transform: translateY(50%);
    z-index: -2;
    width: 110px;
    height: 110px;
  }

  .main-visual-bg-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.7;
  }

  .main-visual-bg-right {
    position: absolute;
    bottom: 5%;
    right: 0px;
    transform: translateY(50%);
    z-index: -2;
    width: 110px;
    height: 110px;
  }

  .main-visual-image {
    position: relative;
    z-index: 2;
    max-width: 400px;
    height: auto;
    width: 100%;
  }

  /* メッセージ */
  .hero-messages {
    position: absolute;
    bottom: 1.8rem;
    right: 0rem;
    z-index: 3;
    margin-top: 0;
  }

  .hero-messages-part2 {
    position: absolute;
    bottom: 0.5rem;
    right: 1rem;
    z-index: 3;
    margin-top: 0;
  }

  .hero-message-main {
    font-size: 1.2rem;
    font-weight: bold;
    color: #da3990;
    margin-bottom: 0.2rem;
  }

  .hero-message-main .message-part1 {
    font-size: 16px;
    text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white;
    margin-right: 1rem;
  }

  .hero-message-main .message-part2 {
    font-size: 18px;
    margin-left: 0rem;
    text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white;
  }

  .hero-message-sub {
    font-size: 14px;
    color: #fff;
    background: #da3990;
    padding: 0.1rem 1rem 0.2rem 1rem;
    border-radius: 20px 0 0 20px;
    margin: -0.7rem 0 0 auto;
    margin-right: -1rem;
    font-weight: bold;
    text-align: right;
    width: fit-content;
    display: block;
    position: relative;
    z-index: 10;
  }

  .hero-message-sub .highlight-text {
    font-size: 16px;
  }

  .action-section-naka {
    position: relative;
    overflow: hidden;
    margin-top: -70px;
  }

  .footer-logo {
    font-size: 29px;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.1em;
    display: block;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: visible;
    text-align: center;
  }
  @media (max-width: 395px) {
    .footer-logo {
      font-size: 23px;
    }
    .sukisuki-subtitle-main {
      font-size: 27px !important;
    }
  }

  /* 最新情報セクション */
  .latest-info-section {
    padding: 1rem 0 2rem 0;
  }

  .info-cards {
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .latest-info-title {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .info-card {
    padding: 1.5rem;
  }

  /* お悩みセクション */
  .worries-section {
    padding: 2rem 1rem;
  }

  .worries-banner {
    padding: 0.5rem 1rem;
    margin-bottom: 2rem;
  }

  .worries-card {
    padding: 1.5rem;
  }

  /* LIVE STATIONセクション */
  .live-station-section {
    padding: 0 0 0px 0;
  }

  /* アバウトセクション */
  .about-section {
    padding: 3rem 1rem;
  }

  .about-icon {
    margin-bottom: 1rem;
  }

  .about-title {
    margin-bottom: 1rem;
  }

  .about-description {
    margin-bottom: 2rem;
  }

  .about-recommendation {
    margin-bottom: 1rem;
  }

  .about-character {
    margin-bottom: 1rem;
  }

  /* 参加費用セクション */
  /* .cost-section {
    padding: 1rem 1rem 3rem 1rem;
    padding-top: 100px;
  } */

  .cost-background {
    margin: 20px 0 0 0;
  }

  .cost-content {
    padding: 2rem;
    margin-right: 2rem;
  }

  .sukisuki-bg-top-right-bg {
    position: absolute;
    top: 3970px;
    left: 50vw;
    right: 0;
    z-index: 0;
    overflow: hidden;
  }
  .right-bg {
    right: 0;
    max-width: 50vw;
    width: auto;
    height: auto;
  }
  .sukisuki-bg-top-left-bg {
    position: absolute;
    top: 5850px;
    right: 60vw;
    z-index: 0;
  }

  .sukisuki-bg2-image {
    width: 425px;
    height: auto;
  }

  /* プロセスセクション */
  .process-section {
    padding: 2rem 1rem;
  }

  .process-step {
    padding: 2rem;
    margin-bottom: 2rem;
  }

  .step-header {
    margin-bottom: 1rem;
  }

  .step-number {
    padding: 0.5rem 1rem;
  }

  .step-description {
    margin-bottom: 1.5rem;
  }

  /* 実施事例セクション */
  .example-section-wrapper {
    padding: 3rem 0 2rem 0;
    background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
    background-size: 10px 10px;
  }

  .example-section {
    padding: 0rem 1rem;
  }

  .example-container {
    padding: 1.5rem;
  }

  .example-title-button {
    padding: 0.8rem 2rem;
    width: auto;
    margin: 20px auto 1.5rem auto;
    cursor: default;
  }

  /* Q&Aセクション */
  .qa-tab-button {
    padding: 0.8rem 2rem;
    width: auto;
    margin: 20px auto 1.5rem auto;
  }

  .qa-question-row {
    margin-bottom: 1rem;
  }

  /* SUKISUKIセクション */
  .sukisuki-section {
    padding: 3rem 1rem;
  }

  .sukisuki-title-section {
    margin-bottom: 3rem;
  }

  .sukisuki-title-bg {
    padding: 0.7rem 1.5rem;
    margin-bottom: 1rem;
  }

  .sukisuki-subtitle-main {
    margin: 10px 0 0.5rem 0;
  }

  /* ライブ配信セクション */
  .live-stream-section {
    padding: 0rem 1rem;
  }

  .live-container {
    padding: 1.5rem;
  }

  .actual-screen-button {
    background: #ffe3f2;
    color: #982da6;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 3px 3px 0 #da3990;
    padding: 0.8rem 2rem;
    width: auto;
    margin: 20px auto 1.5rem auto;
    cursor: default;
  }

  .video-feed {
    height: 500px;
  }

  .video-container {
    /* max-width: 400px; */
    margin: 0 auto;
    background: white;
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .video-wrapper {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    margin: 0 auto;
    overflow: hidden;
    background: linear-gradient(135deg, #ffb3d1, #ffc0cb);
    background-image: radial-gradient(
        circle at 20% 30%,
        rgba(255, 255, 255, 0.3) 2px,
        transparent 2px
      ),
      radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
    background-size: 30px 30px, 20px 20px;
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}

/* ヒーローセクション */
.hero-section {
  background: #ffe3f2;
  margin-bottom: 0;
  padding: 2rem 1rem 0 1rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* ヒーローコンテンツ（デフォルト） */
.hero-content {
  position: relative;
  z-index: 2;
}

.hero-background {
  position: relative;
  z-index: 2;
}

.hero-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 20% 20%,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px
    ),
    radial-gradient(circle at 80% 40%, rgba(255, 255, 255, 0.2) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.25) 1.5px, transparent 1.5px);
  background-size: 30px 30px, 50px 50px, 40px 40px;
  background-repeat: repeat;
  opacity: 0.6;
  z-index: 1;
}

/* ロゴとキャッチコピー */
.hero-header {
  position: relative;
  z-index: 3;
  margin-bottom: 1rem;
}

.hero-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.logo-image {
  max-width: 200px;
  height: auto;
}

.hero-subtitle {
  font-size: 1rem;
  color: #666;
  margin: 0;
  font-weight: bold;
}

/* メインタイトル */
/* .hero-title-container {
  position: relative;
  z-index: 3;
  margin: -1rem 0 2rem 0;
} */

/* .title-bg-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.8;
} */

/* .title-bg-top-left {
  position: absolute;
  top: -15px;
  left: -20px;
  z-index: 1;
  width: 110px;
  height: 110px;
} */

/* .title-bg-top-left-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.7;
} */

.title-logo {
  width: 100%;
  z-index: 2;
}

/* 中央のメインビジュアル */
/* .hero-main-visual {
  position: relative;
  z-index: 1;
  margin: -3.5rem 0 1rem 0;
  display: flex;
  justify-content: center;
} */

/* .main-visual-bg-left {
  position: absolute;
  bottom: 0%;
  left: -15px;
  transform: translateY(50%);
  z-index: -2;
  width: 110px;
  height: 110px;
} */

/* .main-visual-bg-center-left {
  position: absolute;
  bottom: 50%;
  left: 15%;
  transform: translateY(50%);
  z-index: -1;
  width: 110px;
  height: 110px;
} */

/* .main-visual-bg-center-right {
  position: absolute;
  bottom: 40%;
  right: 10%;
  transform: translateY(50%);
  z-index: -1;
  width: 110px;
  height: 110px;
} */

/* .main-visual-bg-right {
  position: absolute;
  bottom: 5%;
  right: 0px;
  transform: translateY(50%);
  z-index: -2;
  width: 110px;
  height: 110px;
} */

/* .main-visual-bg-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.7;
} */

.main-visual-image {
  /* position: relative;
  z-index: 2;
  max-width: 400px;
  height: auto; */
  width: 100%;
}

/* 左右のファンキャラクター */
.hero-fans {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;
  padding: 0 2rem;
}

.fan-left,
.fan-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.fan-character {
  max-width: 120px;
  height: auto;
  margin-bottom: 0.5rem;
}

.reaction-icons {
  display: flex;
  gap: 0.5rem;
  position: absolute;
  top: -10px;
  right: -10px;
}

.reaction {
  font-size: 1.2rem;
  animation: bounce 2s infinite;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 0.2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* グッズ表示 */
.hero-goods {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
}

.goods-image {
  max-width: 200px;
  height: auto;
}

/* お悩みセクション */
.worries-section {
  background: #f8f9fa;
}

.worries-banner {
  background: #ff6b9d;
  color: #fff;
  border-radius: 20px;
  display: inline-block;
  font-weight: bold;
}

.worries-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.worries-card {
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.worries-avatar .avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #ff6b9d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.worries-text {
  flex: 1;
}

.worry-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.worry-icon {
  font-size: 1.2rem;
}

.worry-text {
  font-size: 0.9rem;
  color: #333;
}

/* LIVE STATIONセクション */
.live-station-section {
  background: #ffe3f2;
  text-align: center;
  position: relative;
  overflow: hidden;
  /* min-height: 100vh; */
}

/* 左側の縦書きテキスト */
/* .vertical-title {
  position: absolute;
  left: 5px;
  top: 36%;
  transform: translateY(-50%);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 32px;
  color: #f8c1de;
  font-weight: 900;
  -webkit-text-stroke: 0.5px #f8c1de;
  text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
  z-index: 1;
  letter-spacing: 0em;
} */

/* 右側の縦書きテキスト（180度回転）
.vertical-title-right {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%) rotate(180deg);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 32px;
  color: #f8c1de;
  font-weight: 900;
  -webkit-text-stroke: 0.5px #f8c1de;
  text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
  z-index: 1;
  letter-spacing: 0em;
  white-space: nowrap;
} */

/* 上部の三角形バナー */
.live-station-header {
  position: relative;
  padding: 0;
}

/* .header-triangle {
  position: relative;
  height: 200px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 3rem 0;
  overflow: hidden;
} */

/* .header-arrow-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: 1;
} */

/* .header-characters {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  pointer-events: none;
  z-index: 2;
} */

/* .character-keychain {
  position: absolute;
  top: 30px;
  left: 0px;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .character-peek {
  position: absolute;
  top: 15px;
  right: 8px;
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.character-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
} */

/* .header-text {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  z-index: 3;
}

.header-text-main {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 1.2rem;
  margin-top: -25px;
}

.header-text-sub {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0.7rem;
  margin-top: -10px;
}

.header-text-highlight {
  font-size: 16px;
  font-weight: bold;
  color: #ffef00;
  text-decoration: underline;
  margin-top: -8px;
} */

/* アイコンセクション */
/* .live-station-icons-section {
  padding: 0;
  margin-top: -100px;
  position: relative;
  z-index: 4;
} */

/* .icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.realtimekuji-image {
  max-width: 60%;
  height: auto;
  object-fit: contain;
} */

/* ロゴセクション */
/* .live-station-logo-section {
  padding: 0rem 1rem 2rem;
  margin-top: -30px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
} */

/* .sukisuki-logo-image {
  max-width: 70%;
  height: auto;
  object-fit: contain;
} */

/* .logo-description {
  font-size: 18.33px;
  font-weight: bold;
  color: #000;
  line-height: 1.6;
  max-width: 400px;
  margin: -20px auto 0;
} */

/* キャラクター画像セクション
.character-images-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1rem;
  margin-top: -50px;
} */
/*
.character-image-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.character-image-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
}

.character-image {
  max-width: 140px;
  height: auto;
  object-fit: contain;
} */

/* キャラクターイラストレーション */
.live-station-characters {
  background: #ffb3d1;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
}

.character-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.character-phone {
  background: white;
  border-radius: 20px;
  padding: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.phone-screen {
  font-size: 2rem;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 10px;
}

.character-person {
  font-size: 3rem;
}

.character-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.idea-bubble {
  font-size: 2rem;
  background: #ffb3d1;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
}

/* CTAボタンセクション */
.live-station-cta {
  background: #ffb3d1;
  padding: 2rem 1rem;
}

.cta-container {
  background: #ffb3d1;
  border: 3px solid #8e44ad;
  border-radius: 20px;
  padding: 2rem;
  max-width: 600px;
  margin: 0 auto;
}

.cta-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
}

.cta-block:last-child {
  margin-bottom: 0;
}

.cta-icon {
  font-size: 2rem;
  background: #e0aaff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.line-icon {
  background: #00c851;
  color: white;
}

.cta-text {
  color: white;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.cta-button {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

/* .pdf-button {
  background: #d63384;
  color: white;
} */

/* .line-button {
  background: #ffef00;
  color: #000;
}

.online-button {
  background: #8e44ad;
  color: white;
} */

.button-arrow {
  font-size: 0.8rem;
}

/* アバウトセクション */
.about-section {
  background: #fff;
  text-align: center;
}

.about-background {
  position: relative;
}

.about-icon {
  font-size: 3rem;
}

.about-title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
}

.about-description {
  font-size: 1.1rem;
  color: #666;
}

.about-recommendation {
  font-size: 1.3rem;
  font-weight: bold;
  color: #333;
}

.about-character {
  font-size: 3rem;
}

.about-service-box {
  background: #f8f9fa;
  border: 2px solid #ff6b9d;
  border-radius: 15px;
  padding: 1rem;
  font-weight: bold;
  color: #333;
  display: inline-block;
}

/* 参加費用0円セクション
.cost-section {
  background: #ffe3f2;
  position: relative;
  overflow: hidden;
}

.cost-pig-image {
  position: absolute;
  width: 130px;
  left: 0.5rem;
  height: auto;
  z-index: 10;
}

.cost-background {
  position: relative;
  max-width: 1200px;
  display: flex;
  align-items: center;
  min-height: 400px;
}

.cost-content {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  margin-right: 2rem;
  flex: 1;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.cost-content::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 45%;
  transform: translateX(-40%);
  transform: rotate(-90deg);
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-top: 25px solid white;
}

.cost-piggy-bank {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.piggy-bank-icon {
  font-size: 3rem;
  margin-right: 1rem;
}

.cost-bubble {
  background: #ffeb3b;
  border: 3px solid #9c27b0;
  border-radius: 15px;
  padding: 0.8rem 1.2rem;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.cost-bubble::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid #9c27b0;
}

.cost-label {
  font-size: 0.9rem;
  color: #9c27b0;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.cost-amount {
  font-size: 1.8rem;
  color: #9c27b0;
  font-weight: bold;
}

.cost-highlight {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 3rem;
}

.highlight-text-naka {
  text-decoration: underline;
  text-decoration-color: #ffeb3b;
  text-decoration-thickness: 6px;
  font-size: 18px;
  font-weight: bold;
  color: #da3990;
  margin-right: 0.5rem;
  margin-bottom: 10px;
}

.highlight-image-container {
  position: absolute;
  top: 0.5rem;
  right: 1.8rem;
  z-index: 1;
}

.highlight-image {
  width: 24px;
  height: 24px;
}

.exclamation-marks {
  color: #9c27b0;
  font-size: 1.2rem;
  font-weight: bold;
}

.cost-description p {
  margin: 0.5rem 0;
  font-size: 14px;
  color: #333;
  line-height: 1.2;
}

.cost-illustration {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.illustration-bubble {
  padding: 0.8rem 1.2rem;
  font-size: 1.1rem;
  color: #da3990;
  font-weight: bold;
  margin-top: -1rem;

  position: relative;
}

.illustration-man {
  position: relative;
  display: flex;
  align-items: center;
}

.man-figure {
  margin-right: 1rem;
  position: relative;
  z-index: 2;
}

.man-figure img {
  width: 170px;
  height: auto;
  margin-top: -10px;
} */

.decorative-lines {
  position: absolute;
  left: -2rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.line-purple {
  width: 60px;
  height: 8px;
  background: #9c27b0;
  transform: rotate(-30deg);
  margin-bottom: 0.5rem;
}

.line-pink {
  width: 50px;
  height: 8px;
  background: #ff6b9d;
  transform: rotate(-30deg);
  margin-bottom: 0.5rem;
}

.dots {
  width: 20px;
  height: 20px;
  background: radial-gradient(circle, white 2px, transparent 2px);
  background-size: 8px 8px;
}

.vertical-brand {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
  font-size: 1.2rem;
  font-weight: bold;
  color: rgba(255, 107, 157, 0.7);
  letter-spacing: 0.2em;
  white-space: nowrap;
}

/* 参加費用セクション レスポンシブ */
@media (max-width: 1080px) {
  .cost-section {
    padding: 1rem 2rem 2rem 2rem;
  }

  .vertical-title-right {
    font-size: 32px;
    right: 5px;
    top: 55%;
  }

  .pig-container {
    position: relative;
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  .cost-pig-image {
    position: absolute;
    width: 150px;
    top: -30px;
    left: -20px;
    z-index: 10;
  }

  .cost-background {
    flex-direction: column;
    min-height: auto;
  }

  .cost-content {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1.5rem;
  }

  .cost-piggy-bank {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .piggy-bank-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .cost-bubble::before {
    display: none;
  }

  .cost-bubble {
    margin-top: 1rem;
  }

  .illustration-man {
    flex-direction: column;
    align-items: center;
  }

  .man-figure {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .decorative-lines {
    position: static;
    transform: none;
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .vertical-brand {
    position: static;
    transform: none;
    text-align: center;
    margin-top: 2rem;
    font-size: 1rem;
  }
}

/* プロセスセクション */
.process-section {
  background: #fff;
}

.process-step {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.step-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.step-number {
  background: #ff6b9d;
  color: #fff;
  border-radius: 20px;
  font-weight: bold;
}

.step-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.step-description {
  font-size: 1rem;
  color: #666;
}

.step-illustrations {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.step-character {
  font-size: 2rem;
}

/* 例セクション */
.examples-section {
  background: #fff;
  padding: 2rem 1rem;
}

.example-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.tab-button {
  background: #ff6b9d;
  color: #fff;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
}

.tab-button.active {
  background: #d63384;
}

.example-content {
  display: flex;
  justify-content: center;
}

.example-card {
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.example-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.example-avatar {
  font-size: 2rem;
}

.example-info {
  flex: 1;
}

.example-name {
  font-weight: bold;
  color: #333;
}

.example-followers {
  font-size: 0.9rem;
  color: #666;
}

.example-bow {
  font-size: 1.5rem;
}

.example-comments {
  margin-bottom: 1rem;
}

.comment {
  background: #f8f9fa;
  padding: 0.5rem;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.example-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.like-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.example-pagination {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

/* Q&Aセクション */
.qa-tab-button {
  background: #ffe3f2;
  color: #333;
  border: 3px solid #982da6;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: bold;
  /* cursor: pointer; */
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
  cursor: default;
}

/* .qa-tab-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(142, 68, 173, 0.3);
} */

.qa-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  overflow: hidden;
}

.qa-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.qa-question-row {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.qa-answer-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-bottom: 2rem;
}

.process-step {
  max-width: 800px;
  margin: 0 auto 2rem;
}

.example-tabs {
  gap: 2rem;
}

.image-container {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  padding: 1rem;
  z-index: 2;
  pointer-events: none;
}

h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2.5rem;
  color: #fff;
  line-height: 1.4;
  text-shadow: 0 1px 1.5px rgba(0, 0, 0, 0.4), 0 0 6px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 1.2rem;
  margin-bottom: 1.7rem;
  color: #fff;
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.4), 0 0 8px rgba(0, 0, 0, 0.3);
}

.description {
  font-size: 0.9rem;
  color: black;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 1px #a0a0a0, /* グレーを少し濃く＆少しブラー */ 0 4px 6px rgba(0, 0, 0, 0.4),
    /* 黒影はブラーをやや減らして濃さをキープ */ 0 0 1px #fff, /* 白ぼかしは控えめに */ 0 1px 0 #fff;
}

.sp-only {
  display: inline;
}

.moyamoya {
  background: #cdc3e9;
  overflow-x: hidden;
}

/* 2列レイアウトのスタイル */
/* .moyamoya-two-column {
  display: flex;
  gap: 2rem;
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.moyamoya-column {
  flex: 1;
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #982da6;
}

.moyamoya-person {
  text-align: center;
  margin-bottom: 0rem;
}

.person-avatar {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

.person-avatar-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 0.5rem;
}

.person-label {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.moyamoya-concerns {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.concern-item {
  background: #ffe3f2;
  border-radius: 20px;
  padding: 1rem 1rem;
  text-align: center;
  width: 80%;
  box-sizing: border-box;
  margin: 0 auto;
}

.concern-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #982da6;
  margin-bottom: 0.5rem;
  line-height: 1.4;
}

.concern-desc {
  font-size: 0.8rem;
  color: #333;
  line-height: 1.5;
} */

/* レスポンシブデザイン */
@media (max-width: 1080px) {
  .moyamoya-two-column {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .moyamoya-column {
    padding: 1rem;
  }

  .person-avatar {
    font-size: 2.5rem;
  }

  .person-avatar-image {
    width: 140px;
    height: 140px;
  }

  .concern-title {
    font-size: 14px;
  }

  .concern-desc {
    font-size: 12px;
  }
  /* 2列レイアウトのスタイル */
  .moyamoya-two-column {
    display: flex;
    gap: 2rem;
    padding: 2rem 1rem;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }

  .moyamoya-column {
    flex: 1;
    background: #fff;
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid #982da6;
  }

  .moyamoya-person {
    text-align: center;
    margin-bottom: 0rem;
  }

  .person-avatar {
    font-size: 3rem;
    margin-bottom: 0.5rem;
  }

  .person-avatar-image {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 0.5rem;
  }

  .person-label {
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
  }

  .moyamoya-concerns {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .concern-item {
    background: #ffe3f2;
    border-radius: 20px;
    padding: 1rem 1rem;
    text-align: center;
    width: 80%;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .concern-title {
    font-size: 1.2rem;
    font-weight: bold;
    color: #982da6;
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }

  .concern-desc {
    font-size: 0.8rem;
    color: #333;
    line-height: 1.5;
  }
  .header-triangle {
    position: relative;
    height: 200px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem 3rem 0;
    overflow: hidden;
  }

  @media (min-width: 465px) {
    .header-triangle {
      height: 210px;
    }
  }
  @media (min-width: 490px) {
    .header-triangle {
      height: 220px;
    }
  }
  @media (min-width: 515px) {
    .header-triangle {
      height: 230px;
    }
    .header-text-main {
      font-size: 14px !important;
      margin-bottom: 1.6rem !important;
    }
    .header-text-sub {
      font-size: 20px !important;
    }
    .header-text-highlight {
      font-size: 20px !important;
      margin-top: 6px !important;
    }
  }
  @media (min-width: 535px) {
    .header-triangle {
      height: 240px;
    }
  }
  @media (min-width: 555px) {
    .header-triangle {
      height: 250px;
    }
  }
  @media (min-width: 580px) {
    .header-triangle {
      height: 260px;
    }
    .live-station-icons-section {
      margin-top: -120px !important;
    }
    .header-text-main {
      font-size: 18px !important;
      margin-bottom: 1.8rem !important;
    }
    .header-text-sub {
      font-size: 24px !important;
    }
    .header-text-highlight {
      font-size: 24px !important;
      margin-top: 6px !important;
    }
  }
  @media (min-width: 605px) {
    .header-triangle {
      height: 270px;
    }
  }
  @media (min-width: 630px) {
    .header-triangle {
      height: 280px;
    }
  }
  @media (min-width: 660px) {
    .header-triangle {
      height: 290px;
    }
  }
  @media (min-width: 680px) {
    .header-triangle {
      height: 300px;
    }
    .header-text-main {
      font-size: 20px !important;
      margin-bottom: 2.2rem !important;
    }
    .header-text-sub {
      font-size: 26px !important;
    }
    .header-text-highlight {
      font-size: 26px !important;
      margin-top: 16px !important;
    }
  }
  @media (min-width: 700px) {
    .header-triangle {
      height: 310px;
    }
  }
  @media (min-width: 720px) {
    .header-triangle {
      height: 320px;
    }
    .live-station-icons-section {
      margin-top: -140px !important;
    }
  }
  @media (min-width: 721px) and (max-width: 749px) {
    .header-triangle {
      height: 330px;
    }
  }
  /* @media (min-width: 760px) {
    .header-triangle {
      height: 340px;
    }
  }
  @media (min-width: 800px) {
    .header-triangle {
      height: 350px;
    }
    .live-station-icons-section {
      margin-top: -160px !important;
    }
    .header-text-main {
      font-size: 22px !important;
      margin-bottom: 2.6rem !important;
    }
    .header-text-sub {
      font-size: 28px !important;
    }
    .header-text-highlight {
      font-size: 28px !important;
      margin-top: 18px !important;
    }
  }
  @media (min-width: 820px) {
    .header-triangle {
      height: 360px;
    }
  }
  @media (min-width: 840px) {
    .header-triangle {
      height: 370px;
    }
  }
  @media (min-width: 860px) {
    .header-triangle {
      height: 380px;
    }
  }
  @media (min-width: 880px) {
    .header-triangle {
      height: 390px;
    }
    .live-station-icons-section {
      margin-top: -160px !important;
    }
    .header-text-main {
      font-size: 24px !important;
      margin-bottom: 3rem !important;
    }
    .header-text-sub {
      font-size: 32px !important;
    }
    .header-text-highlight {
      font-size: 32px !important;
      margin-top: 20px !important;
    }
  }
  @media (min-width: 910px) {
    .header-triangle {
      height: 400px;
    }
  }
  @media (min-width: 930px) {
    .header-triangle {
      height: 410px;
    }
  }
  @media (min-width: 950px) {
    .header-triangle {
      height: 420px;
    }
  }
  @media (min-width: 970px) {
    .header-triangle {
      height: 430px;
    }
  }
  @media (min-width: 990px) {
    .header-triangle {
      height: 440px;
    }
  }
  @media (min-width: 1020px) {
    .header-triangle {
      height: 450px;
    }
  }
  @media (min-width: 1040px) {
    .header-triangle {
      height: 460px;
    }
  }
  @media (min-width: 1060px) {
    .header-triangle {
      height: 470px;
    }
  } */

  .header-text {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    text-align: center;
    z-index: 3;
  }

  .header-text-main {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 1.2rem;
    margin-top: -25px;
  }

  .header-text-sub {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0.7rem;
    margin-top: -10px;
  }

  .header-text-highlight {
    font-size: 16px;
    font-weight: bold;
    color: #ffef00;
    text-decoration: underline;
    margin-top: -8px;
  }

  /* アイコンセクション */
  .live-station-icons-section {
    padding: 0;
    margin-top: -100px;
    position: relative;
    z-index: 4;
  }

  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .realtimekuji-image {
    max-width: 60%;
    height: auto;
    object-fit: contain;
  }
  .header-characters {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    pointer-events: none;
    z-index: 2;
  }
  .character-keychain {
    position: absolute;
    top: 30px;
    left: 0px;
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .character-peek {
    position: absolute;
    top: 15px;
    right: 8px;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .character-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  /* キャラクター画像セクション */
  .character-images-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 1rem;
    margin-top: -50px;
  }
  @media (min-width: 750px) {
    .character-images-section {
      margin-top: -140px;
    }
  }

  .character-image-left {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 750px) {
    .character-image-left {
      margin-right: 200px;
    }
  }

  .character-image-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
  }

  .character-image {
    max-width: 140px;
    height: auto;
    object-fit: contain;
  }

  .sukisuki-logo-image {
    max-width: 70%;
    height: auto;
    object-fit: contain;
  }
  /* ロゴセクション */
  .live-station-logo-section {
    padding: 0rem 1rem 2rem;
    /* margin-top: -30px; */
  }

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
  .logo-description {
    font-size: 18.33px;
    font-weight: bold;
    color: #000;
    line-height: 1.6;
    max-width: 400px;
    margin: -20px auto 0;
  }

  /* BG1セクション */
  .bg-1-section {
    padding: 0;
    margin-top: -80px;
    position: relative;
    z-index: 4;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: visible;
    transform: translateX(46%);
  }
  .bg-1-section-left {
    position: absolute;
    left: -260px;
    top: 3580px;
    z-index: 999;
  }
  .bg-1-section-right {
    position: absolute;
    right: 0;
    top: 0;
  }

  .bg-1-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bg-1-container-left {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bg-1-image {
    max-width: 20%;
    height: auto;
    object-fit: contain;
  }
  .bg-1-image-left {
    max-width: 20%;
    height: auto;
    object-fit: contain;
  }

  /* 左側の縦書きテキスト */
  .vertical-title {
    position: absolute;
    left: 5px;
    top: 36%;
    transform: translateY(-50%);
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 32px;
    color: #f8c1de;
    font-weight: 900;
    -webkit-text-stroke: 0.5px #f8c1de;
    text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
    z-index: 1;
    letter-spacing: 0em;
  }

  /* 右側の縦書きテキスト（180度回転） */
  .vertical-title-right {
    position: absolute;
    right: -25px;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 32px;
    color: #f8c1de;
    font-weight: 900;
    -webkit-text-stroke: 0.5px #f8c1de;
    text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
    z-index: 1;
    letter-spacing: 0em;
    white-space: nowrap;
  }
}

.section-moyamoya {
  padding: 2.5rem 1rem 1rem 1rem;
  text-align: center;
}

.moyamoya-title-wrap {
  position: relative;
  width: 100%;
  margin-bottom: 0.5em;
  overflow: visible;
}
.moyamoya-title-wrap h3 {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  line-height: 1.5;
  width: 70%;
  margin: 0 auto;
  color: white;
  text-shadow: none;
  background-color: #982da6;
  padding: 0.3rem 0rem;
  /* border-radius: 12px; */
  border: 2px solid #982da6;
  position: relative;
  z-index: 1;
}

.moyamoya-icon-abs {
  position: absolute;
  height: auto;
  z-index: 2;
  width: 70px;
  right: 4%;
  top: -20px;
}

/* .moyamoya-left-icon,
.moyamoya-right-icon {
  position: absolute;
  height: auto;
  z-index: 10;
  width: 40px;
  top: 50%;
  transform: translateY(-50%);
}

.moyamoya-left-icon {
  left: 3%;
} */

.moyamoya-right-icon {
  right: 3%;
}

/* .moyamoya-bg-right {
  position: absolute;
  top: 120%;
  right: -25px;
  transform: translateY(-50%);
  width: 120px;
  height: 120px;
  z-index: 0;
  opacity: 0.7;
} */

.moyamoya-list {
  display: flex;
  flex-direction: row;
  gap: 0rem;
  align-items: flex-start;
  overflow-x: auto;
  /* padding-bottom: -1rem; */
}

.moyamoya-balloon {
  position: relative;
  width: 310px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.moyamoya-balloonmigi {
  position: relative;
  width: 310px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-left: 1rem; */
  margin-top: -1rem;
  /* margin-right: 1rem; */
}
.moyamoya-balloonhidari {
  position: relative;
  width: 430px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-left: 1rem; */
  margin-top: -1rem;
  margin-left: 1rem;
}

.header-arrow-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: 1;
}

.balloon-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
  pointer-events: none;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.balloon-bg-shita {
  width: 105%;
  height: 105%;
}

.balloon-content {
  position: relative;
  z-index: 2;
  width: 80%;
  color: #222;
  background: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  overflow: hidden;
}

.balloon-title {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 0rem;
  margin-top: 2.3rem;
  /* margin-left: -0.5rem; */
  text-align: center;
  width: 100%;
  min-height: 3.9em;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}

.line-break {
  display: none;
}

.balloon-titlegyaku {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 0rem;
  margin-top: 2.2rem;
  margin-left: 0rem;
  text-align: center;
  width: 100%;
  min-height: 3.9em;
  display: block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  white-space: pre-line;
}
.balloon-titlegyakushita {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 0rem;
  margin-top: 2.5rem;
  margin-left: 0rem;
  text-align: center;
  width: 100%;
  min-height: 3.9em;
  display: block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  white-space: pre-line;
}

.balloon-desc {
  font-size: 12px;
  color: #444;
  margin-top: -0.9rem;
  margin-left: 0;
  text-align: center;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  padding: 0 5px;
}

.moyamoya-row {
  display: flex;
  align-items: flex-start;
  gap: 0rem;
  margin: 0rem 0;
  border-bottom: 1px solid black;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 1rem;
}

.moyamoya-illust-wrap {
  position: relative;
  min-width: 100px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.moyamoya-illust {
  height: 220px;
  width: auto;
  display: block;
  margin-left: 50px;
  margin-right: 30px;
}

.realtime-kujibiki-section {
  background: #fff;
  padding: 2rem 1rem 1.5rem 1rem;
  text-align: center;
  margin-bottom: 2rem;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.lightbulb-bg {
  position: relative;
  margin-bottom: 1.5rem;
  margin-top: 3rem;
}
.lightbulb-img {
  width: 210px;
  position: absolute;
  left: 50%;
  top: -30px;
  transform: translateX(-50%);
  opacity: 0.6;
  z-index: 1;
}
.realtime-kujibiki-text {
  position: relative;
  z-index: 2;
  font-size: 18px;
  color: #444;
  font-weight: bold;
  margin-bottom: 3rem;
  text-shadow: 0 2px 8px #fff;
  line-height: 1.4;
}

.realtime-kujibiki-text-seconed {
  margin-top: -1rem;
}
.realtime-kujibiki-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
}

.btn-reserve {
  background: #e94b8b;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  border: none;
  border-radius: 32px;
  padding: 1rem 2.5rem;
  box-shadow: 0 4px 8px #f8bfcf55;
  cursor: pointer;
}
/* .btn-pdf {
  background: #f8bfcf;
  color: #fff;
  font-size: 1.1rem;
  font-weight: bold;
  border: none;
  border-radius: 32px;
  padding: 1rem 2.5rem;
  box-shadow: 0 4px 8px #e94b8b55;
  cursor: pointer;
} */
.invite-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  box-sizing: border-box;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin: 0 auto;
  max-width: 800px;
  padding: 0 1rem;
}

.invite-illust {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.invite-illust img {
  width: 120px;
  height: auto;
}
.invite-illust-caption {
  text-align: center;
  font-size: 14px;
  color: #888;
  font-weight: bold;
  margin-bottom: 0.2em;
  letter-spacing: 0.05em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.18), 0 1px 0 #fff;
}
.invite-balloon {
  background: #fff7e6;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ccc;
  padding: 0.6rem 0.8rem;
  margin-right: 10px;
  position: relative;
  min-width: 120px;
  max-width: 220px;
  box-sizing: border-box;
  text-align: left;
  word-break: break-all;
  white-space: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 1;
  flex-grow: 0;
}

.invite-balloon::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 12px 18px 12px 0;
  border-style: solid;
  border-color: transparent #fff7e6 transparent transparent;
  filter: drop-shadow(-2px 2px 2px #ccc);
}
.invite-balloon-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-top: 8px;
  margin-bottom: 10px;
  position: relative;
  z-index: 10;
}

.invite-balloon-desc {
  font-size: 11px;
  text-align: center;
}

.good-section {
  background: #ffeef3;
  padding: 20px 0 20px 0;
  text-align: center;
}

.good-section-catch {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.05em;
  display: inline-block;
  line-height: 1.5;
  /* 縁取りを強調 */
  text-shadow: -2px -2px 0 #888, 2px -2px 0 #888, -2px 2px 0 #888, 2px 2px 0 #888, 0px 2px 0 #888,
    2px 0px 0 #888, 0px -2px 0 #888, -2px 0px 0 #888, 0 9px 8px #b9b9b9, 0 1px 0 #fff;
}

.point-1 {
  background: #ffeef3;
  padding: 0rem 1.5rem 2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.point-2 {
  padding: 0rem 1.5rem 2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.point-3 {
  background: #ffeef3;
  padding: 1rem 1.5rem 2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.point-4 {
  padding: 1rem 1.5rem 2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.point1-header-img {
  width: 400px;
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 0rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.point1-content {
  text-align: left;
  margin-left: 0;
}
.point1-title {
  font-size: 1.8rem;
  font-weight: 900;
  margin-bottom: 1rem;
  text-align: left;
  color: #ba191c;
  padding-top: 2rem;
}
.point1-title-img {
  margin-bottom: 0.5rem;
}

.point1-maintext {
  font-size: 16px;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: bold;
}

.point1-desc {
  font-size: 14px;
  color: #444;
  text-align: center;
}
.video-section-wrapper {
  padding: 3rem 0 2rem 0;
  background: #ffe3f2;
  background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
  background-size: 10px 10px;
}

.video-section {
  margin: 0;
  padding: 0rem 1rem;
  background: #ffe3f2;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
  background-size: 20px 20px;
  position: relative;
  overflow: hidden;
}

/* .video-container {
  max-width: 400px;
  margin: 0 auto;
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
} */

.video-title-button {
  background: #ffe3f2;
  color: #333;
  border: 3px solid #982da6;
  border-radius: 15px;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  font-weight: bold;
  width: auto;
  margin: 20px auto 1.9rem auto;
  /* cursor: pointer; */
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
  cursor: default;
}

/* .video-title-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(142, 68, 173, 0.3);
} */

/* .video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  margin: 0 auto;
  overflow: hidden;
  background: linear-gradient(135deg, #ffb3d1, #ffc0cb);
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px
    ),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 30px 30px, 20px 20px;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
} */

/* 実施事例セクション */
.example-section-wrapper {
  background: #ffe3f2;
  background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
  background-size: 10px 10px;
}

.action-section-background {
  background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
  background-size: 10px 10px;
}

.example-section {
  margin: 0;
  background: #ffe3f2;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
  background-size: 20px 20px;
  position: relative;
  overflow: hidden;
}

/* .example-container {
  max-width: 400px;
  margin: 0 auto;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
} */

.example-title-button {
  background: #ffe3f2;
  color: #333;
  border: 3px solid #982da6;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: bold;
  /* cursor: pointer; */
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
  cursor: default;
}

/* .example-title-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(142, 68, 173, 0.3);
} */

.example-feed {
  background: linear-gradient(135deg, #ffb3d1, #ffc0cb);
  border-radius: 15px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  /* height: 500px; */
  position: relative;
  overflow: hidden;
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px
    ),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 30px 30px, 20px 20px;
}

.example-slider-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.example-slider-wrapper {
  display: flex;
  transition: transform 0.3s ease-in-out;
  height: 100%;
}

.example-slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.example-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0;
  padding: 0;
}

@media (max-width: 1080px) {
  .example-section-wrapper {
    padding: 1rem 0 2rem 0;
  }

  .example-section {
    margin: 0rem 0;
    padding: 0rem 1rem;
  }

  .example-container {
    /* max-width: 400px; */
    margin: 0 auto;
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 1rem;
  }

  .qa-question-balloon {
    display: inline-block;
    border-radius: 25px;
    background: #ffe3f2;
    padding: 1em 1.5em;
    font-size: 1.1em;
    position: relative;
    max-width: 300px;
    min-width: 80%;
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  .qa-answer-balloon {
    display: inline-block;
    border-radius: 25px;
    background: #ffe3f2;
    padding: 1em 1.5em;
    font-size: 1.1em;
    position: relative;
    max-width: 300px;
    min-width: 80%;
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 0.5em;
  }
}

.example-section h3 {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #333;
}

.example-image {
  width: 100%;
  max-width: 800px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ui-section {
  background: #ffeef3;
  padding: 2rem 1rem 1.5rem 1rem;
  text-align: center;
  margin-bottom: 2rem;
}

.ui-section h3 {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #333;
}

.slider-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  overflow: hidden;
}

.slider-wrapper {
  display: flex;
  transition: transform 0.3s ease-in-out;
}

.slide {
  flex: 0 0 100%;
  width: 100%;
}

.slide img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.slider-dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  transition: background-color 0.3s;
}

.dot.active {
  background: #e94b8b;
}

.qa-question-row {
  display: flex;
  align-items: center;
  margin-bottom: 1.2em;
}
.qa-q {
  color: #982da6;
  font-weight: bold;
  font-size: 18px;
  font-family: inherit;
  flex-shrink: 0;
}
/* .qa-question-balloon {
  display: inline-block;
  border-radius: 25px;
  background: #ffe3f2;
  padding: 1em 1.5em;
  font-size: 1.1em;
  position: relative;
  max-width: 300px;
  min-width: 80%;
  min-height: 60px;
  display: flex;
  align-items: center;
  gap: 0.5em;
} */

.qa-question-balloon::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ffe3f2;
}

.qa-text {
  font-size: 12px;
  /* font-weight: bold; */
  text-align: left;
  display: flex;
  align-items: center;
  white-space: normal;
  height: 100%;
}

.qa-answer-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1.5em;
}
/* .qa-answer-balloon {
  display: inline-block;
  border-radius: 25px;
  background: #ffe3f2;
  padding: 1em 1.5em;
  font-size: 1.1em;
  position: relative;
  max-width: 300px;
  min-width: 80%;
  min-height: 60px;
  display: flex;
  align-items: center;
  gap: 0.5em;
} */

.qa-answer-balloon::after {
  content: "";
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #ffe3f2;
}

.qa-a {
  color: #da3990;
  font-weight: bold;
  font-size: 18px;
  font-family: inherit;
  flex-shrink: 0;
}

.QA-content {
  border-radius: 20px;
  padding: 1rem;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  /* margin-bottom: 2rem; */
}

.QA-section {
  padding: 2rem 1rem 0rem 1rem;
  background: #fff;
}

.QA-section h3 {
  margin-bottom: 1rem;
}

.qa-banner {
  width: 100%;
  text-align: center;
  margin: -3rem 0 0 0;
}
.qa-banner img {
  max-width: 800px;
  width: 80%;
  height: auto;
  /* border-radius: 16px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
}

.company {
  background: #fff;
  padding: 2rem 1rem;
}

.company-title-button {
  background: #ffe3f2;
  color: #333;
  border: 3px solid #982da6;
  border-radius: 15px;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  font-weight: bold;
  width: auto;
  margin: 20px auto 1.5rem auto;
  /* cursor: pointer; */
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
  cursor: default;
}

/* .company-title-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(142, 68, 173, 0.3);
} */

.company-info {
  max-width: 600px;
  margin: 0 auto;
}

.company-info-item {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 2px solid #f0acc4;
}

.company-info-item:last-child {
  border-bottom: 2px solid #f0acc4;
}

.company-info-label {
  font-weight: bold;
  font-size: 14px;
  color: #982da6;
  text-align: left;
  width: 120px;
  flex-shrink: 0;
  margin-right: 1rem;
}

.company-info-content {
  color: #333;
  font-size: 12px;
  text-align: left;
  flex: 1;
  line-height: 1.5;
}
.company h3 {
  margin-top: 2rem;
  font-size: 1.3rem;
  font-weight: bold;
}

.company-table {
  width: 100%;
  max-width: 600px;
  margin: 2rem auto;
  background: #fff;
  font-size: 14px;
}
.company-table th,
.company-table td {
  border: 1px solid #eee;
  padding: 0.8em 1em;
  text-align: left;
  vertical-align: middle;
}
.company-table th {
  background: #fafafa;
  font-weight: bold;
  width: 160px;
  color: #555;
}
.company-table td {
  color: #222;
}

/* 参加費用無料セクションのスタイル */
.free-participation-section {
  background: #fff;
  padding: 3rem 1rem;
  margin: 2rem 0;
}

.free-participation-container {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.free-participation-content {
  background: #fff;
  border: 3px solid;
  border-image: linear-gradient(45deg, #87ceeb 0%, #ffb6c1 100%) 1;
  border-radius: 20px;
  padding: 2rem;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* 貯金箱イラスト */
.piggy-bank-illustration {
  position: absolute;
  top: -20px;
  left: 20px;
  z-index: 2;
}

.piggy-bank {
  width: 60px;
  height: 50px;
  position: relative;
}

.piggy-body {
  width: 50px;
  height: 40px;
  background: #8a2be2;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  position: absolute;
  top: 5px;
  left: 5px;
}

.piggy-snout {
  width: 15px;
  height: 12px;
  background: #8a2be2;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  left: 45px;
}

.piggy-ear {
  width: 8px;
  height: 8px;
  background: #8a2be2;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  left: 8px;
}

.piggy-legs {
  width: 40px;
  height: 8px;
  background: #8a2be2;
  border-radius: 4px;
  position: absolute;
  top: 45px;
  left: 10px;
}

.piggy-tail {
  width: 6px;
  height: 15px;
  background: #8a2be2;
  border-radius: 3px;
  position: absolute;
  top: 20px;
  left: -3px;
  transform: rotate(-20deg);
}

.dotted-line {
  position: absolute;
  top: 10px;
  left: 65px;
  width: 200px;
  height: 100px;
  border: 2px dashed #8a2be2;
  border-radius: 10px;
  border-bottom: none;
  border-right: none;
}

/* 0円バッジ */
.zero-yen-badge {
  position: absolute;
  top: -15px;
  right: 20px;
  background: #ffd700;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(255, 215, 0, 0.3);
}

.zero-yen-text {
  font-size: 1.2em;
  font-weight: bold;
  color: #333;
}

/* ハイライトメッセージ */
.highlight-message {
  background: #ffd700;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  margin: 1rem 0 1.5rem 0;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.2);
}

.asterisk {
  color: #ff69b4;
  font-weight: bold;
  font-size: 1.1em;
  margin-right: 0.3em;
}

.free-text {
  color: #ff69b4;
  font-weight: bold;
  font-size: 1.1em;
}

/* 説明テキスト */
.description-text {
  margin-top: 1.5rem;
  line-height: 1.6;
}

.description-text p {
  margin: 0.5rem 0;
  color: #333;
  font-size: 1em;
}

/* レスポンシブデザイン */
@media (max-width: 1080px) {
  .moyamoya-bg-right {
    position: absolute;
    top: 120%;
    right: -25px;
    transform: translateY(-50%);
    width: 120px;
    height: 120px;
    z-index: 0;
    opacity: 0.7;
  }

  .free-participation-content {
    padding: 1.5rem;
  }

  .piggy-bank-illustration {
    top: -15px;
    left: 15px;
  }

  .piggy-bank {
    width: 50px;
    height: 40px;
  }

  .dotted-line {
    width: 150px;
    height: 80px;
  }

  .zero-yen-badge {
    width: 60px;
    height: 60px;
    top: -10px;
    right: 15px;
  }

  .zero-yen-text {
    font-size: 1em;
  }

  .highlight-message {
    padding: 0.6rem 1rem;
    font-size: 0.9em;
  }

  .description-text p {
    font-size: 0.9em;
  }
  /* 参加費用0円セクション */
  .cost-section {
    background: #ffe3f2;
    position: relative;
    overflow: hidden;
  }

  .cost-pig-image {
    position: absolute;
    width: 150px;
    left: 0.1rem;
    height: auto;
    z-index: 10;
  }

  .cost-background {
    position: relative;
    max-width: 1200px;
    display: flex;
    align-items: center;
    min-height: 400px;
  }

  .cost-content {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    margin-right: 2rem;
    flex: 1;
    position: relative;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  .cost-content::after {
    content: "";
    position: absolute;
    bottom: -6px;
    left: 45%;
    transform: translateX(-40%);
    transform: rotate(-90deg);
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 25px solid white;
  }

  .cost-piggy-bank {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .piggy-bank-icon {
    font-size: 3rem;
    margin-right: 1rem;
  }

  .cost-bubble {
    background: #ffeb3b;
    border: 3px solid #9c27b0;
    border-radius: 15px;
    padding: 0.8rem 1.2rem;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .cost-bubble::before {
    content: "";
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #9c27b0;
  }

  .cost-label {
    font-size: 0.9rem;
    color: #9c27b0;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .cost-amount {
    font-size: 1.8rem;
    color: #9c27b0;
    font-weight: bold;
  }

  .cost-highlight {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    /* justify-content: flex-end; */
    padding-left: 20vw;
  }
  @media (min-width: 750px) and (max-width: 1080px) {
    .cost-highlight {
      padding-left: 0vw !important;
    }
  }

  @media (min-width: 550px) and (max-width: 660px) {
    .cost-highlight {
      padding-left: 25vw !important;
    }
  }
  @media (min-width: 661px) and (max-width: 749px) {
    .cost-highlight {
      padding-left: 30vw !important;
    }
  }

  .highlight-text-naka {
    text-decoration: underline;
    text-decoration-color: #ffeb3b;
    text-decoration-thickness: 6px;
    font-size: 18px;
    font-weight: bold;
    color: #da3990;
    /* margin-right: 4rem; */
    margin-top: 35px;

    margin-bottom: 10px;
  }

  .highlight-image-container {
    position: absolute;
    top: 1rem;
    /* right: 1rem; */
    margin-left: 70vw;
    z-index: 1;
  }
  @media (min-width: 450px) and (max-width: 500px) {
    .highlight-image-container {
      margin-left: 65vw !important;
    }
  }
  @media (min-width: 501px) and (max-width: 549px) {
    .highlight-image-container {
      margin-left: 60vw !important;
    }
  }
  @media (min-width: 550px) and (max-width: 1080px) {
    .highlight-image-container {
      margin-left: 63vw !important;
    }
  }
  @media (min-width: 600px) and (max-width: 650px) {
    .highlight-image-container {
      margin-left: 60vw !important;
    }
  }
  @media (min-width: 650px) and (max-width: 660px) {
    .highlight-image-container {
      margin-left: 58vw !important;
    }
  }
  @media (min-width: 700px) and (max-width: 749px) {
    .highlight-image-container {
      margin-left: 60vw !important;
    }
  }
  @media (min-width: 900px) and (max-width: 1080px) {
    .highlight-image-container {
      margin-left: 60vw !important;
    }
  }

  .highlight-image {
    width: 24px;
    height: 24px;
  }

  .live-station-section {
    min-height: 0vh;
  }

  .pig-speech-bubble {
    background: white;
    border-radius: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    position: relative;
    width: 100%;
    height: 193px;
    /* margin-left: 50px; */
    margin-top: 20px;
  }

  .pig-speech-bubble::after {
    content: "";
    position: absolute;
    right: 50%;
    top: 100%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid white;
  }

  .exclamation-marks {
    color: #9c27b0;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .cost-description p {
    margin: 0.2rem 0;
    font-size: 14px;
    color: #333;
    line-height: 1.2;
  }

  .cost-illustration {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .illustration-bubble {
    padding: 0.8rem 1.2rem;
    font-size: 1.1rem;
    color: #da3990;
    font-weight: bold;
    margin-top: -1rem;

    position: relative;
  }

  .illustration-man {
    position: relative;
    display: flex;
    align-items: center;
  }

  .man-figure {
    margin-right: 1rem;
    position: relative;
    z-index: 2;
  }

  .man-figure img {
    width: 180px;
    height: auto;
    margin-top: 20px;
  }
  .right-section {
    margin-top: 2rem;
  }

  .man-bubble-content {
    font-size: 18px;
    font-weight: bold;
    color: #da3990;
  }
}

/* SUKISUKIライブステーション説明セクションのスタイル */
.sukisuki-section {
  background: #f0acc4;
}

.sukisuki-container {
  max-width: 1000px;
  margin: 0 auto;
}

.sukisuki-title-section {
  text-align: center;
}

.sukisuki-title-bg {
  background: #ffe3f2;
  border: 3px solid #982da6;
  border-radius: 15px;
  display: inline-block;
  box-shadow: 5px 5px 0 #da3990, 5px 5px 0 #da3990;
  position: relative;
  z-index: 10;
}

/* .sukisuki-main-title {
  color: #982da6;
  font-size: 16px;
  font-weight: extrabold;
  margin: 0;
  text-shadow: none;
} */

.sukisuki-subtitle {
  color: #8a2be2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sukisuki-subtitle-main {
  font-size: 45px;
  font-weight: 900;
  color: #f6c2d6;
  white-space: nowrap;
  position: relative;
  z-index: 1;
}

/* .sukisuki-subtitle-text {
  font-size: 14px;
  font-weight: bold;
  margin: -18px 0 0 0;
  color: #982da6;
} */

/* .point-section {
  background: white;
  border: 3px solid #8a2be2;
  border-radius: 20px;
  margin: 2rem 0;
  padding: 2rem;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1), 8px 8px 0px #da3990;
  text-align: left;
}

.point-header {
  background: #982da6;
  color: white;
  padding: 0.4rem 1rem;
  display: inline-block;
  margin: -2.2rem 0 0.5rem -2rem;
  font-weight: bold;
  font-size: 12px;
}

.point-text {
  font-size: 12px;
  margin-right: 8px;
}

.point-number {
  font-size: 24px;
}

.point-title {
  color: #982da6;
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 0.5rem 0;
  text-decoration: underline;
  text-decoration-color: #ffef00;
  text-decoration-thickness: 6px;
  text-underline-offset: -2px;
  line-height: 1.5;
  text-align: center;
}

.point-subtitle {
  color: #8a2be2;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0 0 1rem 0;
}

.point-description {
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 0.7rem 0;
  text-align: center;
} */

/* .horizontal-line {
  height: 3px;
  background: #8a2be2;
  margin: 0rem -2rem 2rem -2rem;
} */

.highlight-yellow {
  background: #ffeb3b;
  padding: 0.2rem 0.4rem;
  border-radius: 5px;
  font-weight: bold;
}

/* POINT 1 スタイル */
.point-illustration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}

/* .point-illustration-image {
  width: 100%;
  max-width: 1000px;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  transform: scale(1.1);
} */

.bubble-icon {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

/* POINT 2 スタイル */
.point-2-illustration {
  margin-top: 2rem;
}

.point2-margin {
  margin-top: 1rem;
}

.excitement-scene {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.fan-reactions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.fan-reaction {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.fan-avatar {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.reaction-bubble {
  background: #ffeb3b;
  border-radius: 10px;
  padding: 0.8rem;
  font-weight: bold;
  color: #333;
  font-size: 0.9rem;
}

.reaction-text {
  background: #ffeb3b;
  border-radius: 10px;
  padding: 0.8rem 1.2rem;
  font-weight: bold;
  color: #333;
  font-size: 0.9rem;
  margin: 0.5rem;
}

.streamer-phone {
  position: relative;
  text-align: center;
}

.phone-screen {
  background: #333;
  border-radius: 20px;
  padding: 1.5rem;
  width: 200px;
  height: 150px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.streamer-avatar {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.fan-profiles {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.profile {
  width: 30px;
  height: 30px;
  background: #ffeb3b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.congratulations-bubble {
  background: #ffeb3b;
  border-radius: 15px;
  padding: 1rem 1.5rem;
  font-weight: bold;
  color: #333;
  margin-top: 1rem;
  font-size: 1.1rem;
}

/* POINT 3 スタイル */
.point-3-illustration {
  margin-top: 2rem;
  text-align: center;
}

.streamer-announcement {
  margin-bottom: 2rem;
}

.phone-screen {
  background: #333;
  border-radius: 20px;
  padding: 1.5rem;
  width: 200px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.streamer-avatar {
  font-size: 3rem;
}

.announcement-bubble {
  background: #ffeb3b;
  border-radius: 15px;
  padding: 1rem 1.5rem;
  font-weight: bold;
  color: #333;
  margin-top: 1rem;
  font-size: 1.1rem;
  display: inline-block;
}

.fans-gathering {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.fan {
  font-size: 2rem;
  padding: 0.5rem;
  background: #f0f0f0;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.merchandise-items {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.merch-item {
  font-size: 2rem;
  padding: 0.5rem;
  background: #f0f0f0;
  border-radius: 10px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* POINT 4 スタイル */
.point-4-illustration {
  margin-top: 2rem;
  text-align: center;
}

.service-icons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.service-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-circle {
  width: 80px;
  height: 80px;
  background: #8a2be2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  margin-bottom: 0.5rem;
}

.icon-label {
  color: #8a2be2;
  font-weight: bold;
  font-size: 1rem;
}

.service-representative {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.rep-avatar {
  font-size: 3rem;
}

.rep-bubble {
  background: #ffeb3b;
  border-radius: 15px;
  padding: 1rem 1.5rem;
  font-weight: bold;
  color: #333;
  font-size: 1.1rem;
}

/* レスポンシブデザイン */
@media (max-width: 1080px) {
  .sukisuki-main-title {
    font-size: 16px;
    color: #982da6;
    font-size: 16px;
    font-weight: extrabold;
    margin: 0;
    text-shadow: none;
  }

  .sukisuki-subtitle-main {
    font-size: 33px;
    margin: 10px 0 0.5rem 0;
    white-space: nowrap;
    position: relative;
    z-index: 1;
  }

  .sukisuki-subtitle-text {
    font-size: 1rem;
    font-size: 14px;
    font-weight: bold;
    margin: -18px 0 0 0;
    color: #982da6;
    position: relative;
    z-index: 2;
  }

  .point-section {
    background: white;
    border: 3px solid #8a2be2;
    border-radius: 20px;
    margin: 2rem 0;
    padding: 2rem;
    position: relative;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1), 8px 8px 0px #da3990;
    text-align: left;
  }

  @media (min-width: 750px) {
    .point-section {
      padding: 0 0 1.5rem 0;
    }
  }

  .point-header {
    background: #982da6;
    color: white;
    padding: 0.4rem 1rem;
    display: inline-block;
    margin: -2.2rem 0 0.5rem -2rem;
    font-weight: bold;
    font-size: 12px;
  }

  @media (min-width: 750px) {
    .point-header {
      margin: 2rem 0 2rem 0rem;
      padding: 1rem 2rem;
    }
    .point-number {
      font-size: 30px !important;
    }
    .point-text {
      font-size: 16px !important;
      /* margin-right: 8px; */
    }
  }

  .point-text {
    font-size: 12px;
    margin-right: 8px;
  }

  .point-number {
    font-size: 24px;
  }

  .point-title {
    color: #982da6;
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 0.5rem 0;
    text-decoration: underline;
    text-decoration-color: #ffef00;
    text-decoration-thickness: 6px;
    text-underline-offset: -2px;
    line-height: 1.5;
    text-align: center;
  }

  .point-subtitle {
    color: #8a2be2;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0 0 1rem 0;
  }

  .point-description {
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 0.7rem 0;
    text-align: center;
  }

  @media (min-width: 750px) {
    .point-title-container {
      position: absolute;
      top: 30px;
      margin-left: 180px;
      padding-bottom: 5rem;
      z-index: 10;
    }
    .point-title {
      font-size: 20px;
      text-align: left;
    }
  }

  .point-title {
    font-size: 16px;
  }

  .point-illustration {
    flex-direction: column;
    gap: 2rem;
  }

  .horizontal-line {
    height: 3px;
    background: #8a2be2;
    margin: 0rem -2rem 2rem -2rem;
  }

  @media (min-width: 750px) {
    .horizontal-line {
      margin: 0rem 0rem 2rem 0rem;
    }
  }

  .point-illustration-image {
    width: 100%;
    max-width: 300px;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
    transform: scale(1.1);
  }

  @media (min-width: 750px) {
    .point-illustration-image {
      max-width: 70%;
    }
  }
  .fan-reactions {
    flex-direction: column;
    align-items: center;
  }

  .service-icons {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .service-representative {
    flex-direction: column;
    text-align: center;
  }
}

/* ライブ配信風UIスタイル */
.live-stream-section {
  margin: 0;
  background: #ffe3f2;
  background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
  background-size: 10px 10px;
  position: relative;
  overflow: hidden;
}

.live-container {
  /* max-width: 400px; */
  margin: 0 auto;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  /* border: 2px solid #ff69b4; */
}

/* .actual-screen-button {
  background: #ffe3f2;
  color: #982da6;
  border: 3px solid #982da6;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s ease;
  display: block;
  box-shadow: 3px 3px 0 #da3990;
} */

/* .actual-screen-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(142, 68, 173, 0.3);
} */

.video-feed {
  background: linear-gradient(135deg, #ffb3d1, #ffc0cb);
  /* border: 3px solid #333; */
  border-radius: 15px;
  position: relative;
  overflow: hidden;
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.3) 2px,
      transparent 2px
    ),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 30px 30px, 20px 20px;
}

/* .ui-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
} */

.ui-slider-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 15px;
}

.ui-slider-wrapper {
  display: flex;
  transition: transform 0.3s ease-in-out;
  height: 100%;
}

.ui-slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
}

.character-info {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10;
}

.character-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  border: 2px solid #ff69b4;
}

.character-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.character-details {
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.character-name {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 2px;
}

.character-title {
  font-size: 0.7rem;
  opacity: 0.9;
}

.top-right-icons {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.icon-btn:hover {
  background: white;
  transform: scale(1.1);
}

.bottom-left-animation {
  position: absolute;
  bottom: 60px;
  left: 15px;
  display: flex;
  gap: 5px;
  z-index: 10;
}

.bee-icon {
  font-size: 1.2rem;
  animation: float 2s ease-in-out infinite;
}

.bee-icon:nth-child(2) {
  animation-delay: 0.5s;
}

.bee-icon:nth-child(3) {
  animation-delay: 1s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.chat-overlay {
  position: absolute;
  bottom: 80px;
  left: 15px;
  right: 15px;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.chat-message {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
  padding: 8px 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(5px);
  animation: slideIn 0.5s ease-out;
}

.chat-message.highlighted {
  border: 2px solid #ffd700;
  background: rgba(255, 255, 255, 0.95);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: white;
  flex-shrink: 0;
}

.message-content {
  flex: 1;
}

.username {
  font-size: 0.7rem;
  font-weight: bold;
  color: #666;
  margin-bottom: 2px;
}

.message {
  font-size: 0.8rem;
  color: #333;
  line-height: 1.2;
}

.comment-input-area {
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
}

.comment-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 15px;
  font-size: 0.8rem;
  outline: none;
  backdrop-filter: blur(5px);
}

.comment-input::placeholder {
  color: #999;
}

.input-icons {
  display: flex;
  gap: 5px;
}

.input-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.input-icon:hover {
  background: white;
  transform: scale(1.1);
}

.pagination-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 1rem;
  padding-bottom: 1rem;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #ff69b4;
  transform: scale(1.2);
}

.dot:hover {
  background: #ff69b4;
  transform: scale(1.1);
}

/* PC版レイアウト（1440px以上） */
/* PC版のスタイル */

@media (max-width: 400px) {
  .highlight-text-naka {
    font-size: 17px !important;
  }
}

@media (min-width: 540px) and (max-width: 749px) {
  .video-feed {
    height: 700px !important;
  }
}

/* 750-1080pxのメディアクエリ */
@media (min-width: 750px) and (max-width: 1080px) {
  .live-station-section {
    width: 100%;
    position: relative;
    margin-bottom: 0;
    padding-bottom: 1rem;
  }

  .live-station-header {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 calc((100vw - 1080px) / 2);
  }

  .live-station-icons-section {
    max-width: 1080px;
    margin: 0 auto;
    margin-top: 150px;
    /* padding: 0 calc((100vw - 1080px) / 2); */
    z-index: 4;
  }

  .realtimekuji-image {
    max-width: 400px;
    margin-top: -110px;
  }

  /* .header-arrow-image {
    width: 100%+360px;
    height: auto;
    object-fit: cover;
    z-index: 1;
  } */

  .header-text {
    position: absolute;
    top: 0%;
    /* left: 35%; */
    /* transform: translate(-50%, -50%); */
    color: white;
    text-align: center;
    z-index: 3;
  }

  .header-text-main {
    font-size: 16px !important;
    font-weight: bold;
    /* margin-bottom: -50px; */
    margin-top: 69px;
    margin-bottom: 0px !important;
  }

  .header-text-highlight {
    font-size: 18px !important;
    font-weight: bold;
    color: #ffef00;
    /* text-decoration: underline; */
    margin-top: 7px !important;
  }

  .header-text-highlight-underline {
    text-decoration: underline;
    color: #ffef00;
  }

  .header-text-highlight-sub {
    font-size: 16px;
    color: white;
  }

  /* アクションセクション */
  .action-section {
    width: 100%;
  }

  .action-container {
    max-width: 1080px;
    margin: 0 auto;
    margin-bottom: 40px;
    padding: 0;
    display: flex;
    position: relative;
    flex-direction: row;
    /* gap: 2rem; */
    background: #f0acc4;
    border: 3px solid #982da6;
    box-shadow: 12px 12px 0 #da3990;
    border-radius: 20px;
    z-index: 999;
  }

  .action-container-naka {
    max-width: 1080px;
    margin: 0 auto;
    margin-bottom: 40px;
    padding: 0px 0 10px 0;
    /* padding: 0 calc((100vw - 1080px) / 2); */
    display: flex;
    position: relative;
    flex-direction: row;
    /* gap: 2rem; */
    background: #f0acc4;
    border: 3px solid #982da6;
    box-shadow: 12px 12px 0 #da3990;
    border-radius: 20px;
    z-index: 10;
  }

  .action-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 1rem; */
    padding: 1rem 0rem 0rem 0rem;
    border-radius: 15px;
  }

  .action-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: #f0acc4; */
    /* border-radius: 50%; */
    margin-bottom: 0.5rem;
  }

  .action-icon-image {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-left: 0px;
  }

  .action-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 1rem; */
    text-align: center;
    margin: 0px 5px;
  }

  .action-title {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    margin: 0;
    line-height: 1.3;
  }

  .action-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 25px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    /* min-width: 269px; */
    width: 100%;
    max-width: 250px;
  }

  /* 左右のボタンを真ん中に近づける */
  .action-item:first-child {
    padding-left: 1rem;
  }

  .action-item:last-child {
    padding-right: 1rem;
  }

  .pdf-button {
    background: #d63384;
    color: #fff;
    border: 2px solid #982da6;
    box-shadow: 0 2px 4px rgba(214, 51, 132, 0.3);
  }

  .pdf-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .line-button {
    background: #ffef00;
    color: #982da6;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
  }

  .line-button:hover {
    color: #982da6;
  }

  .online-button {
    background: #982da6;
    color: #fff;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(152, 45, 166, 0.3);
  }

  .online-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .action-footer {
    text-align: center;
    margin-top: -2.7rem;
    padding: 0 0 0.7rem 0;
    position: relative;
    z-index: 3;
    width: 100%;
    display: block;
  }
  .footer-logo {
    font-size: 50px;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.1em;
    display: block;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: visible;
    text-align: center;
  }

  .action-section-naka {
    width: 100%;
    /* margin-top: 30px; */
  }

  .action-container-naka {
    max-width: 1080px;
    margin: 0 auto;

    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .action-section-margin {
    padding-top: 50px;
  }

  .action-section-white {
    padding-top: 3rem;
  }
  .moyamoya-bg-left {
    display: none;
  }
  .moyamoya-title-wrap h3 {
    font-size: 20px;
  }
  .moyamoya-title-highlight {
    font-size: 26px !important;
  }
  .cost-highlight {
    /* margin-left: 200px !important; */
    /* margin-right: 150px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .highlight-text-naka {
    font-size: 24px !important;
  }
  .cost-description p {
    font-size: 18px !important;
  }
  .pig-speech-bubble {
    height: 180px;
  }

  /* 画像の上下が切れないようにする */
  .ui-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
  }
  .video-feed {
    height: 700px !important;
  }
  @media (min-width: 900px) {
    .video-feed {
      height: 800px !important;
    }
  }

  @media (min-width: 1000px) {
    .video-feed {
      height: 900px !important;
    }
  }
  @media (min-width: 750px) {
    .hero-message-main {
      font-size: 20px !important;
      margin-top: -30px !important;
    }
    .message-part1 {
      font-size: 18px !important;
    }
    .message-part2 {
      font-size: 22px !important;
      /* margin-right: 35px; */
    }
    .hero-message-sub {
      font-size: 18px !important;
      /* margin-top: 2px !important; */
      padding: 0.3rem 2rem 0.4rem 2rem;
      margin-top: -50px !important;
    }
    .highlight-text {
      font-size: 20px !important;
    }
    .hero-message-main .message-part1 {
      margin-right: 30px;
    }
  }
  @media (min-width: 900px) {
    .hero-message-main {
      font-size: 24px !important;
      margin-top: -50px !important;
    }
    .message-part1 {
      font-size: 22px !important;
    }
    .message-part2 {
      font-size: 26px !important;
      margin-right: 13px;
    }
    .hero-message-sub {
      font-size: 22px !important;
      /* margin-top: 2px !important; */
      padding: 0.4rem 2rem 0.5rem 2rem;
      margin-top: -65px !important;
    }
    .highlight-text {
      font-size: 24px !important;
    }
    .hero-message-main .message-part1 {
      margin-right: 30px;
    }
    .hero-message-main-tb {
      margin-bottom: 40px !important;
    }
  }
}

@media (min-width: 1081px) {
  /* 各セクションのコンテナに1080px幅と両側180pxマージンを適用 */
  .hero-section {
    width: 100%;
  }

  .hero-background {
    width: 100%;
  }

  .hero-content {
    max-width: 1080px;
    margin: 0 auto;
    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .title-background {
    position: absolute;
    /* background-color: red; */
    top: -20px;
    right: 50px;
    z-index: -1;
    width: 260px;
    height: 260px;
  }

  .title-bg-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.8;
  }

  .title-bg-top-left-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.8;
  }

  .title-bg-top-left {
    position: absolute;

    top: 0px;
    right: 800px;
    z-index: -1;
    width: 260px;
    height: 260px;
  }
  .title-bg-live-left {
    position: absolute;
    top: 40px;
    right: 0px;
    width: 260px;
    height: 260px;
  }
  .title-bg-cost-left {
    position: absolute;
    top: 0px;
    right: 1000px;
    width: 260px;
    height: 260px;
  }
  .main-visual-image {
    margin-top: -50px;
    z-index: 1;
  }

  .main-visual-bg-center-left {
    position: absolute;
    bottom: 33%;
    left: -10%;
    transform: translateY(50%);
    z-index: -1;
    width: 260px;
    height: 260px;
  }

  .main-visual-bg-center-right {
    position: absolute;
    bottom: 25%;
    left: 85%;
    transform: translateY(50%);
    z-index: -2;
    width: 260px;
    height: 260px;
  }

  .main-visual-bg-left {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateY(50%);
    z-index: -2;
    width: 260px;
    height: 260px;
  }
  .dispay-dod {
    display: none;
  }

  .hero-messages {
    position: absolute;
    bottom: 8rem;
    right: -120px;
    z-index: 3;
    margin-top: 0;
  }

  .hero-message-main {
    text-align: right;
  }
  .hero-message-main .message-part1 {
    font-size: 32px;
    font-weight: bold;
    color: #da3990;
    text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white;
    /* margin-right: 1rem; */
  }

  .hero-messages-part2 {
    position: absolute;
    bottom: 5rem;
    right: -120px;
    z-index: 3;
    margin-top: 0;
  }

  .hero-message-main .message-part2 {
    font-size: 40px;
    font-weight: bold;
    color: #da3990;
    text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white;
    /* margin-right: 1rem; */
  }

  .hero-message-sub {
    font-size: 32px;
    color: #fff;
    background: #da3990;
    padding: 1rem 1rem 1.2rem 2rem;
    border-radius: 40px 0 0 40px;
    margin: -60px -180px 20px auto;

    font-weight: bold;
    text-align: right;
    width: fit-content;
    display: block;
    position: relative;
    z-index: 10;
  }

  @media (max-width: 1415px) {
    .hero-message-sub {
      margin: -60px -163px 20px auto;
    }
    .hero-messages {
      right: -100px;
    }
    .hero-messages-part2 {
      right: -100px;
    }
  }

  @media (max-width: 1385px) {
    .hero-message-sub {
      margin: -60px -153px 20px auto;
    }
    .hero-messages {
      right: -95px;
    }
    .hero-messages-part2 {
      right: -95px;
    }
  }
  @media (max-width: 1370px) {
    .hero-message-sub {
      margin: -60px -143px 20px auto;
    }
    .hero-messages {
      right: -85px;
    }
    .hero-messages-part2 {
      right: -85px;
    }
  }
  @media (max-width: 1345px) {
    .hero-message-sub {
      margin: -60px -133px 20px auto;
    }
    .hero-messages {
      right: -75px;
    }
    .hero-messages-part2 {
      right: -75px;
    }
  }
  @media (max-width: 1330px) {
    .hero-message-sub {
      margin: -60px -123px 20px auto;
    }
    .hero-messages {
      right: -70px;
    }
    .hero-messages-part2 {
      right: -70px;
    }
  }
  @media (max-width: 1315px) {
    .hero-message-sub {
      margin: -60px -113px 20px auto;
    }
    .hero-messages {
      right: -60px;
    }
    .hero-messages-part2 {
      right: -60px;
    }
  }
  @media (max-width: 1290px) {
    .hero-message-sub {
      margin: -60px -103px 20px auto;
    }
    .hero-messages {
      right: -50px;
    }
    .hero-messages-part2 {
      right: -50px;
    }
  }
  @media (max-width: 1265px) {
    .hero-message-sub {
      margin: -60px -93px 20px auto;
    }
    .hero-messages {
      right: -40px;
    }
    .hero-messages-part2 {
      right: -40px;
    }
  }
  @media (max-width: 1240px) {
    .hero-message-sub {
      margin: -60px -83px 20px auto;
    }
    .hero-messages {
      right: -25px;
    }
    .hero-messages-part2 {
      right: -25px;
    }
  }
  @media (max-width: 1215px) {
    .hero-message-sub {
      margin: -60px -73px 20px auto;
    }
    .hero-messages {
      right: -20px;
    }
    .hero-messages-part2 {
      right: -20px;
    }
  }
  @media (max-width: 1190px) {
    .hero-message-sub {
      margin: -60px -63px 20px auto;
    }
    .hero-messages {
      right: -10px;
    }
    .hero-messages-part2 {
      right: -10px;
    }
  }
  @media (max-width: 1165px) {
    .hero-message-sub {
      margin: -60px -53px 20px auto;
    }
    .hero-messages {
      right: 5px;
    }
    .hero-messages-part2 {
      right: 5px;
    }
  }
  @media (max-width: 1140px) {
    .hero-message-sub {
      margin: -60px -43px 20px auto;
    }
    .hero-messages {
      right: 15px;
    }
    .hero-messages-part2 {
      right: 15px;
    }
  }
  @media (max-width: 1115px) {
    .hero-message-sub {
      margin: -60px -33px 20px auto;
    }
    .hero-messages {
      right: 15px;
    }
    .hero-messages-part2 {
      right: 15px;
    }
  }
  @media (max-width: 1090px) {
    .hero-message-sub {
      margin: -60px -23px 20px auto;
    }
    .hero-messages {
      right: 15px;
    }
    .hero-messages-part2 {
      right: 15px;
    }
  }

  .hero-message-sub .highlight-text {
    font-size: 40px;
  }

  .main-visual-bg-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.7;
  }

  .action-section {
    width: 100%;
  }

  .action-container {
    max-width: 1080px;
    margin: 0 auto;
    margin-bottom: 40px;
    padding: 20px 0 10px 0;
    display: flex;
    position: relative;
    flex-direction: row;
    /* gap: 2rem; */
    background: #f0acc4;
    border: 3px solid #982da6;
    box-shadow: 12px 12px 0 #da3990;
    border-radius: 20px;
    z-index: 999;
  }

  .action-container-naka {
    max-width: 1080px;
    margin: 0 auto;
    margin-bottom: 40px;
    padding: 20px 0 10px 0;
    /* padding: 0 calc((100vw - 1080px) / 2); */
    display: flex;
    position: relative;
    flex-direction: row;
    /* gap: 2rem; */
    background: #f0acc4;
    border: 3px solid #982da6;
    box-shadow: 12px 12px 0 #da3990;
    border-radius: 20px;
    z-index: 10;
  }

  /* .action-container {
    max-width: 800px;
    margin: 0 auto;
    background: #f0acc4;
    border: 3px solid #982da6;
    border-radius: 20px;
    position: relative;
    z-index: 2;
    box-shadow: 8px 8px 0 #da3990;
  } */

  .action-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 1rem; */
    padding: 1rem 0rem 1rem 0rem;
    border-radius: 15px;
  }

  .action-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: #f0acc4; */
    /* border-radius: 50%; */
    margin-bottom: 0.5rem;
  }

  .action-icon-image {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }

  .action-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    text-align: center;
  }

  .action-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin: 0;
    line-height: 1.3;
  }

  .action-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 25px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    min-width: 269px;
    width: 100%;
    max-width: 250px;
  }

  /* 左右のボタンを真ん中に近づける */
  .action-item:first-child {
    padding-left: 5rem;
  }

  .action-item:last-child {
    padding-right: 5rem;
  }

  .pdf-button {
    background: #d63384;
    color: #fff;
    border: 2px solid #982da6;
    box-shadow: 0 2px 4px rgba(214, 51, 132, 0.3);
  }

  .pdf-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .line-button {
    background: #ffef00;
    color: #982da6;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
  }

  .line-button:hover {
    color: #982da6;
  }

  .online-button {
    background: #982da6;
    color: #fff;
    border: 2px solid #da3990;
    box-shadow: 0 2px 4px rgba(152, 45, 166, 0.3);
  }

  .online-button:hover {
    background: #b02a5b;
    transform: translateY(-1px);
  }

  .action-footer {
    text-align: center;
    margin-top: -3rem;
    padding: 0 0 0.7rem 0;
    position: relative;
    z-index: 3;
    width: 100%;
    display: block;
  }
  .footer-logo {
    font-size: 100px;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.1em;
    display: block;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: visible;
    text-align: center;
  }
  @media (max-width: 1350px) {
    .footer-logo {
      font-size: 95px;
    }
  }
  @media (max-width: 1280px) {
    .footer-logo {
      font-size: 90px;
    }
  }
  @media (max-width: 1220px) {
    .footer-logo {
      font-size: 85px;
    }
  }
  @media (max-width: 1150px) {
    .footer-logo {
      font-size: 80px;
    }
  }

  .moyamoya {
    width: 100%;
    padding-bottom: 80px;
  }

  .moyamoya-left-icon,
  .moyamoya-right-icon {
    position: absolute;
    height: auto;
    z-index: 10;
    width: 70px;
    top: 50%;
    transform: translateY(-50%);
  }

  .moyamoya-left-icon {
    left: 10%;
  }

  .moyamoya-right-icon {
    right: 10%;
    top: 40px;
  }

  .moyamoya-title-wrap h3 {
    margin: 0;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 1.5;
    width: 60%;
    margin: 0 auto;
    color: white;
    text-shadow: none;
    background-color: #982da6;
    padding: 0.1rem 0rem;
    /* border-radius: 12px; */
    border: 2px solid #982da6;
    position: relative;
    z-index: 1;
    margin-top: 3rem;
  }

  .section-moyamoya {
    /* max-width: 1080px; */
    margin: 0 auto;
    margin-bottom: 2rem;
    padding: 2.5rem calc((100vw - 1080px) / 2) 1rem calc((100vw - 1080px) / 2);
  }

  .moyamoya-bg-right {
    position: absolute;
    top: 150%;
    right: -180px;
    transform: translateY(-50%);
    width: 263px;
    height: 263px;
    z-index: 0;
    opacity: 0.7;
  }
  .moyamoya-bg-left {
    position: absolute;
    top: 1980%;
    left: -150px;
    transform: translateY(-50%);
    width: 263px;
    height: 263px;
    z-index: 0;
    opacity: 0.7;
  }

  .moyamoya-column {
    flex: 1;
    background: #fff;
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid #982da6;
    width: 100%;
    min-height: 512px;
    position: relative;
  }
  .person-avatar-image {
    width: 233px;
    height: auto;
  }

  .moyamoya-two-column {
    /* max-width: 1080px; */
    margin: 0 auto;
    padding: 2rem calc((100vw - 1080px) / 2);
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .moyamoya-person {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 50%;
  }

  .concern-item {
    background: #ffe3f2;
    border-radius: 20px;
    /* padding: 1rem 1rem; */
    text-align: center;
    width: 260px;
    height: 195px;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .concern-item-hidari {
    position: absolute;
    left: 12%;
    top: 38%;
  }

  .concern-item-naka {
    margin-left: 35%;
    position: absolute;
    top: 5%;
  }

  .concern-item-migi {
    margin-left: 60%;
    margin-top: 15%;
    position: absolute;
  }

  .concern-item-migi-d {
    height: 230px;
  }

  .concern-title {
    font-size: 18px;
    font-weight: bold;
    color: #982da6;
    padding: 1.2rem 0rem 0.3rem 0rem;
    line-height: 1.4;
  }

  .concern-desc {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
  }

  .live-station-section {
    width: 100%;
    position: relative;
    margin-bottom: 0;
    padding-bottom: 1rem;
  }

  .live-station-header {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 calc((100vw - 1080px) / 2);
  }

  .live-station-icons-section {
    max-width: 1080px;
    margin: 0 auto;
    margin-top: 150px;
    /* padding: 0 calc((100vw - 1080px) / 2); */
    z-index: 4;
  }

  .realtimekuji-image {
    max-width: 438px;
  }

  /* .header-arrow-image {
    width: 100%+360px;
    height: auto;
    object-fit: cover;
    z-index: 1;
  } */

  .header-text {
    position: absolute;
    top: 0%;
    left: 35%;
    /* transform: translate(-50%, -50%); */
    color: white;
    text-align: center;
    z-index: 3;
  }

  .header-text-main {
    font-size: 24px;
    font-weight: bold;
    /* margin-bottom: 1.2rem; */
    margin-top: 25px;
  }

  .header-text-highlight {
    font-size: 32px;
    font-weight: bold;
    color: #ffef00;
    /* text-decoration: underline; */
    margin-top: 30px;
  }
  @media (max-width: 1400px) {
    .header-text-highlight {
      margin-top: 25px;
    }
  }
  @media (max-width: 1320px) {
    .header-text-highlight {
      margin-top: 20px;
    }
  }
  @media (max-width: 1290px) {
    .header-text-highlight {
      margin-top: 20px;
    }
    .header-text-main {
      margin-top: 15px;
    }
  }

  @media (max-width: 1220px) {
    .header-text-highlight {
      font-size: 28px;
    }
  }
  @media (max-width: 1120px) {
    .header-text-highlight {
      font-size: 26px;
    }
  }

  @media (max-width: 1400px) {
    .stick-hidden {
      display: none;
    }
  }
  .header-text-highlight-underline {
    text-decoration: underline;
    color: #ffef00;
  }

  .header-text-highlight-sub {
    font-size: 24px;
    color: white;
  }

  /* BG1セクション */
  .bg-1-section {
    position: absolute;
    right: -120px;
    top: 80px;
    z-index: 4;
  }

  .bg-1-container {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
  }

  .bg-1-image {
    width: 292px;
    height: auto;
    object-fit: contain;
    max-width: 100%;
  }

  .bg-1-section-left {
    position: absolute;
    left: -100px;
    top: 3150px;
    z-index: 999;
  }

  .bg-1-section-right {
    position: absolute;
    right: 0;
    top: 0;
  }

  .bg-1-container-left {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
  }

  .bg-1-image-left {
    width: 292px;
    height: auto;
    object-fit: contain;
    max-width: 100%;
  }

  /* BG2セクション（PC版用） */
  .bg-2-section {
    position: absolute;
    right: -120px;
    top: 3850px;
    z-index: 4;
    overflow: hidden;
    /* width: 200px; */
  }

  .bg-2-section-bottom {
    position: absolute;
    right: -150px;
    top: 5300px;
    z-index: 4;
    overflow: hidden;
    /* width: 200px; */
  }
  .bg-2-stream-bottom {
    position: absolute;
    right: -150px;
    top: 150px;
    z-index: 4;
    overflow: hidden;
    /* width: 200px; */
  }
  .bg-2-video-bottom {
    position: absolute;
    right: -150px;
    top: 7500px;
    z-index: 4;
    overflow: hidden;
    /* width: 200px; */
  }

  .bg-2-container-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
  }

  /* BG2セクション左側（PC版用） */
  .bg-2-section-left {
    position: absolute;
    left: -150px;
    top: 4550px;
    z-index: 999;
  }

  .bg-2-stream-left {
    position: absolute;
    left: -150px;
    top: 540px;
    z-index: 999;
  }

  .bg-2-example-left {
    position: absolute;
    left: -150px;
    top: 7800px;
    z-index: 999;
  }

  .bg-2-container-left {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
  }

  .live-station-logo-section {
    width: 1080px;
    margin: 0 auto;
    /* padding: 0rem calc((100vw - 1080px) / 2) 2rem calc((100vw - 1080px) / 2); */
  }

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3rem;
  }

  .header-characters {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    pointer-events: none;
    z-index: 2;
  }

  .character-images-section {
    position: absolute;

    z-index: 4;
  }

  .character-keychain {
    position: absolute;
    left: 210px;
    top: 55px;
    /* width: 121px;
    height: auto; */

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .character-peek {
    position: absolute;
    right: 190px;
    top: 70px;
    /* width: 121px;
    height: auto; */

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .character-image-1 {
    width: 279px;
    height: 100%;
    object-fit: contain;
  }

  .character-image-2 {
    width: 238px;
    height: 100%;
    object-fit: contain;
  }

  .character-image-left {
    position: absolute;
    left: 5px;
    top: -200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .character-image-right {
    position: absolute;
    left: 800px;
    top: -200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .character-image-keychain {
    width: 121px;
    height: auto;
  }

  .character-image-peek {
    width: 156px;
    height: auto;
  }

  .sukisuki-logo-image {
    width: 454px;
    height: auto;
    object-fit: contain;
  }

  .logo-description {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    line-height: 1.6;
    /* max-width: 400px; */
    margin: -10px 0 0 0;
  }

  .action-section-naka {
    width: 100%;
    margin-top: 30px;
  }

  .action-container-naka {
    max-width: 1080px;
    margin: 0 auto;

    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .cost-section {
    width: 100%;
    padding-top: 10px;
  }

  .cost-background {
    max-width: 1080px;
    margin: 0 auto;
    /* margin-top: 50px;
    padding-top: 110px;
    padding-bottom: 70px; */
    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .sukisuki-section {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 50px;
    background: #f0acc4;
  }

  .sukisuki-bg-top-right-bg {
    position: absolute;
    top: 3980px;
    left: 60vw;
    right: 0;
    z-index: 0;
    overflow: hidden;
  }
  .right-bg {
    right: 0;
    max-width: 40vw;
    width: auto;
    height: auto;
  }
  .sukisuki-bg-top-left-bg {
    position: absolute;
    top: 5150px;
    right: 61vw;
    z-index: 0;
  }

  .sukisuki-bg-top-left {
    position: absolute;
    top: 500px;
    right: 950px;
  }

  .sukisuki-bg-top-right {
    position: absolute;
    top: 500px;
    left: 985px;
    right: 0;
  }

  .sukisuki-bg-bottom-left {
    position: absolute;
    bottom: 250px;
    right: 990px;
  }

  .sukisuki-bg-bottom-right {
    position: absolute;
    bottom: 250px;
    left: 985px;
    right: 0;
  }

  .sukisuki-bg2-image {
    width: 1083px;
    height: auto;
  }

  .sukisuki-bg-image {
    width: 263px;
    height: 263px;
  }

  .sukisuki-container {
    max-width: 1080px;
    margin: 0 auto;
    position: relative;
    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .sukisuki-title-section {
    padding-top: 70px;
  }

  .sukisuki-main-title {
    font-size: 32px;
    color: #982da6;
    font-weight: extrabold;
    margin: 0;
    text-shadow: none;
    padding: 20px 50px 20px 50px;

    position: relative;
    z-index: 3;
  }

  .sukisuki-title-bg {
    position: relative;
    box-shadow: 10px 10px 0 #da3990, 10px 10px 0 #da3990;
    z-index: 10;
  }

  .sukisuki-main-title {
    position: relative;
    z-index: 3;
  }

  .sukisuki-subtitle-text {
    margin-top: 25px;
    font-size: 24px;
    font-weight: bold;
    position: relative;
    z-index: 2;
  }

  .sukisuki-subtitle-main {
    font-size: 120px;
    position: relative;
    z-index: 1;
  }
  @media (max-width: 1415px) {
    .sukisuki-subtitle-main {
      font-size: 115px;
    }
  }
  @media (max-width: 1370px) {
    .sukisuki-subtitle-main {
      font-size: 110px;
    }
  }
  @media (max-width: 1300px) {
    .sukisuki-subtitle-main {
      font-size: 105px;
    }
  }
  @media (max-width: 1250px) {
    .sukisuki-subtitle-main {
      font-size: 100px;
    }
  }
  @media (max-width: 1200px) {
    .sukisuki-subtitle-main {
      font-size: 95px;
    }
  }
  @media (max-width: 1130px) {
    .sukisuki-subtitle-main {
      font-size: 90px;
    }
  }

  .point-section {
    background: white;
    border: 7px solid #8a2be2;
    border-radius: 20px;
    margin: 2rem 0;
    padding: 2rem;
    position: relative;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1), 12px 12px 0px #da3990;
    text-align: left;
  }

  .point-header {
    background: #982da6;
    color: white;
    padding: 1.5rem 3rem;
    display: inline-block;
    margin: 0rem 0 2rem -2rem;
    font-weight: bold;
    font-size: 12px;
  }

  .point-text {
    font-size: 24px;
    margin-right: 8px;
  }

  .point-number {
    font-size: 52px;
  }

  .point-title {
    color: #982da6;
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 0.5rem 0;
    text-decoration: underline;
    text-decoration-color: #ffef00;
    text-decoration-thickness: 6px;
    text-underline-offset: -2px;
    line-height: 1.5;
    /* text-align: center; */
  }

  .point-description {
    font-size: 16px;
    line-height: 1.5;
    margin: 0 0 0.7rem 0;
    /* text-align: center; */
  }

  .point-title-container {
    position: absolute;
    top: 30px;
    margin-left: 230px;

    z-index: 10;
  }

  .point-illustration {
    flex-direction: column;
    gap: 2rem;
  }

  .horizontal-line {
    height: 7px;
    background: #8a2be2;
    margin: 0rem -2rem 2rem -2rem;
  }

  .action-section-margin {
    padding-top: 50px;
  }

  .point-illustration-image {
    width: 60%;
    /* max-width: 1000px; */
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
    transform: scale(1.1);
  }

  .live-stream-section {
    width: 100%;
    padding-top: 2rem;
    background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
    background-size: 10px 10px;
  }

  .live-container {
    max-width: 1080px;
    margin: 0 auto;
    padding-top: 50px;

    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .actual-screen-button {
    color: #982da6;
    background: #ffe3f2;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 8px 8px 0 #da3990;
    padding: 2rem 4rem 2rem 4rem;
    width: auto;

    margin: 0px auto 2rem auto;
    font-size: 32px;
    cursor: default;
  }

  .video-section-wrapper {
    width: 100%;
    background-image: radial-gradient(circle, #d18dd6 1px, transparent 1px);
    background-size: 10px 10px;
  }

  .video-section {
    max-width: 1080px;
    margin: 0 auto;
    padding: 0;
    /* padding: 0rem calc((100vw - 1080px) / 2); */
  }

  .video-feed {
    max-height: 772px;
  }
  .ui-image {
    /* width: 100%; */
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  .video-container {
    /* max-width: 400px; */
    margin: 0 auto;
    background: white;
    border-radius: 15px;
    padding: 3rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  .video-title-button {
    color: #982da6;
    background: #ffe3f2;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 8px 8px 0 #da3990;
    padding: 2rem 4rem 2rem 4rem;
    width: auto;

    margin: 0px auto 4rem auto;
    font-size: 32px;
  }

  .video-wrapper-container {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  .video-wrapper {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    margin: 0 auto;
    overflow: hidden;
    background: linear-gradient(135deg, #ffb3d1, #ffc0cb);
    background-image: radial-gradient(
        circle at 20% 30%,
        rgba(255, 255, 255, 0.3) 2px,
        transparent 2px
      ),
      radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
    background-size: 30px 30px, 20px 20px;
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
  .example-section-wrapper {
    width: 100%;
    padding-bottom: 3rem;
    padding-top: 1rem;
  }
  .example-container {
    width: 100%;
    margin: 0 auto;
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 3rem;
  }

  .example-title-button {
    color: #982da6;
    background: #ffe3f2;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 8px 8px 0 #da3990;
    padding: 2rem 4rem 2rem 4rem;
    width: auto;

    margin: 0px auto 2rem auto;
    font-size: 32px;
    cursor: default;
  }

  .example-image {
    width: 70%;
    height: 70%;
    object-fit: cover;
    display: block;
    margin: 0;
    padding: 0;
  }

  .example-section {
    max-width: 1080px;
    margin: 0 auto;
    position: relative;
    /* padding: 0rem calc((100vw - 1080px) / 2); */
  }

  .QA-section {
    width: 100%;
    padding: 7rem 1rem 0rem 1rem;
  }
  .qa-tab-button {
    color: #982da6;
    background: #ffe3f2;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 8px 8px 0 #da3990;
    padding: 2rem 4rem 2rem 4rem;
    width: auto;

    margin: 0px auto 2rem auto;
    font-size: 32px;
  }

  .qa-avatar {
    width: 116.5px;
    height: 141px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    flex-shrink: 0;
    overflow: hidden;
  }

  .QA-content {
    max-width: 1080px;
    margin: 0 auto;
    padding: 0 8rem;
    /* padding: 0 calc((100vw - 1080px) / 2); */
  }

  .qa-text {
    font-size: 16px;
    /* font-weight: bold; */
    text-align: left;
    display: flex;
    align-items: center;
    white-space: normal;
    height: 100%;
  }

  .qa-q {
    color: #982da6;
    font-weight: bold;
    font-size: 32px;
    font-family: inherit;
    flex-shrink: 0;
  }

  .qa-a {
    color: #da3990;
    font-weight: bold;
    font-size: 32px;
    font-family: inherit;
    flex-shrink: 0;
  }

  .qa-answer-balloon {
    text-align: right;
    justify-content: flex-end;
  }

  .qa-question-balloon {
    display: inline-block;
    border-radius: 25px;
    background: #ffe3f2;
    padding: 1em 1.5em;
    font-size: 1.1em;
    position: relative;
    /* max-width: 300px; */
    /* min-width: 80%; */
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 0.5em;
    display: inline-block;
    border-radius: 25px;
    background: #ffe3f2;
    padding: 1em 1.5em;
    font-size: 1.1em;
    position: relative;
    /* max-width: 300px; */
    /* min-width: 80%; */
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 0.5em;
  }
  .qa-answer-balloon {
    background: #ffe3f2;
    padding: 1em 1.5em;
    font-size: 1.1em;
    position: relative;
    border-radius: 25px;
    /* max-width: 300px; */
    /* min-width: 80%; */
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  .qa-question-row {
    margin-top: -1rem;
  }

  .qa-answer-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* margin-bottom: 2rem; */
    margin-top: -5rem;
  }

  .company-title-button {
    color: #982da6;
    background: #ffe3f2;
    border: 3px solid #982da6;
    border-radius: 15px;
    font-weight: bold;
    transition: all 0.3s ease;
    display: block;
    box-shadow: 8px 8px 0 #da3990;
    padding: 2rem 4rem 2rem 4rem;
    width: auto;

    margin: 0px auto 2rem auto;
    font-size: 32px;
  }

  .company {
    width: 100%;
  }

  .company-info {
    max-width: 1080px;
    margin: 0 auto;
    padding: 0 8rem;
    /* padding: 0 calc((100vw - 1080px) / 2); */
  }
  .company-info-label {
    font-size: 16px;
  }

  .company-info-content {
    font-size: 16px;
  }

  .latest-info-title {
    font-size: 24px;
    font-weight: bold;
    color: #a544af;
    padding-top: 4rem;
    padding-bottom: 3rem;
  }

  .latest-info-section {
    width: 100%;
    padding-bottom: 3rem;
    margin-top: 2rem;
  }

  .info-card {
    width: 400px;
  }

  .info-cards {
    width: 1080px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    gap: 2rem;
    justify-content: center;
  }

  /* 縦書きテキストの位置調整 */
  /* 左側の縦書きテキスト */
  .vertical-title {
    position: absolute;
    left: 13px;
    top: 315px;
    transform: translateY(-50%);
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 51px;
    color: #f8c1de;
    font-weight: 900;
    -webkit-text-stroke: 0.5px #f8c1de;
    text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
    z-index: 1;
    letter-spacing: 0em;
    white-space: nowrap;
  }

  /* 右側の縦書きテキスト（180度回転） */
  .vertical-title-right {
    position: absolute;
    right: 13px;
    top: 3200px;
    transform: translateY(-50%) rotate(180deg);
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 51px;
    color: #f8c1de;
    font-weight: 900;
    -webkit-text-stroke: 0.5px #f8c1de;
    text-shadow: 0.5px 0.5px 0px rgba(248, 193, 222, 0.3);
    z-index: 3;
    letter-spacing: 0em;
    white-space: nowrap;
  }

  .naka-cost-section {
    background: #ffe3f2;
  }

  /* 参加費用0円セクション */
  .cost-section {
    background: #ffe3f2;
    /* position: relative; */
    overflow: hidden;
  }

  .cost-pig-image {
    position: absolute;
    width: 200px;
    height: auto;
    z-index: 3;
    left: 120px;
    top: 15%;
    transform: translateY(-50%);
  }

  .man-figure img {
    width: 180px;
    height: auto;
  }

  .cost-background {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
    min-height: 300px;
  }

  .left-section {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right-section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding-bottom: 3rem;
  }

  .pig-container {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: flex-start;
    min-height: 250px;
  }

  .man-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .pig-speech-bubble {
    background: white;
    border-radius: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    position: relative;
    width: 500px;
    height: 193px;
    margin-left: 120px;
    z-index: 2;
  }

  .pig-speech-bubble::after {
    content: "";
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid white;
  }

  .man-speech-bubble {
    /* border-radius: 15px; */
    position: relative;
    padding-bottom: 1rem;
    padding-left: 1rem;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  }
  /*
  .man-speech-bubble::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffeb3b;
  } */

  .man-bubble-content {
    font-size: 24px;
    color: #da3990;
    font-weight: bold;
    text-align: center;
    padding: 1rem 1.5rem;
  }

  .piggy-bank-icon {
    font-size: 3rem;
    margin-right: 1rem;
  }

  .cost-bubble {
    background: #ffeb3b;
    border: 3px solid #9c27b0;
    border-radius: 15px;
    /* padding: 0.8rem 1.2rem; */
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .cost-bubble::before {
    content: "";
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #9c27b0;
  }

  .cost-label {
    font-size: 0.9rem;
    color: #9c27b0;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .cost-amount {
    font-size: 1.8rem;
    color: #9c27b0;
    font-weight: bold;
  }

  .cost-highlight {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-left: 3rem; */
  }

  .highlight-text-naka {
    text-decoration: underline;
    text-decoration-color: #ffeb3b;
    /* text-decoration-thickness: 6px; */
    font-size: 24px;
    font-weight: bold;
    color: #da3990;
    margin-right: 80px;
    margin-top: 40px;
    /* margin-bottom: 10px; */
  }

  .highlight-image-container {
    position: absolute;
    top: 1rem;
    right: 80px;
    z-index: 1;
  }

  .highlight-image {
    width: 24px;
    height: 24px;
  }

  .exclamation-marks {
    color: #9c27b0;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .cost-description {
    margin-top: 2.5rem;
  }

  .cost-description p {
    margin: 1rem 0;
    font-size: 16px;
    color: #333;
    line-height: 1.2;
  }

  .cost-illustration {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .illustration-bubble {
    /* padding: 0.8rem 1.2rem; */
    font-size: 24px;
    color: #da3990;
    font-weight: bold;
    /* margin-top: -1rem; */

    position: relative;
  }

  .illustration-man {
    position: relative;
    display: flex;
    align-items: center;
  }

  .man-figure {
    margin-left: 30px;
    position: relative;
    z-index: 2;
  }

  .man-figure img {
    width: 200px;
    height: auto;
    margin-top: 0;
  }
  .info-label {
    font-size: 24px;
  }
  .info-url-bottom {
    font-size: 16px;
  }
  .info-logo-sukisuki {
    width: 140px;
    height: auto;
    margin-left: 2rem;
    object-fit: contain;
  }
  .action-section-white {
    padding-top: 3rem;
  }

  .hero-title-container {
    position: relative;
    z-index: 3;
    /* margin: -1rem 0 2rem 0; */
  }

  .hero-main-visual {
    position: relative;
    z-index: 1;
    /* margin: -3.5rem 0 1rem 0; */
    display: flex;
    justify-content: center;
  }
}

/* レスポンシブ対応 */
@media (max-width: 1080px) {
  .live-stream-section {
    margin: 0rem 0;
    /* padding: 1rem 0.5rem; */
  }

  .live-container {
    padding: 1rem;
  }

  .video-feed {
    height: 400px;
  }
  .ui-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  .character-info {
    top: 10px;
    left: 10px;
  }

  .character-avatar {
    width: 35px;
    height: 35px;
  }

  .character-name {
    font-size: 0.8rem;
  }

  .character-title {
    font-size: 0.6rem;
  }

  .top-right-icons {
    top: 10px;
    right: 10px;
    gap: 5px;
  }

  .icon-btn {
    width: 25px;
    height: 25px;
    font-size: 0.7rem;
  }

  .chat-overlay {
    bottom: 70px;
    left: 10px;
    right: 10px;
  }

  .comment-input-area {
    bottom: 10px;
    left: 10px;
    right: 10px;
  }
}

/* 1081px-1440pxの間で段階的にマージンを縮める - moyamoyaセクション */
@media (min-width: 1081px) and (max-width: 1439px) {
  .section-moyamoya {
    /* max-width: 1080px;
    margin: 0 auto;
    margin-bottom: 2rem; */
    padding: 2.5rem calc((100vw - 1080px) / 2) 1rem calc((100vw - 1080px) / 2);
  }

  .moyamoya-two-column {
    /* max-width: 1080px; */
    /* margin: 0 auto; */
    padding: 2rem calc((100vw - 1080px) / 2);
    /* display: flex;
    flex-direction: column;
    gap: 2rem; */
  }
}

/* PC版用のスタイル
@media (min-width: 1440px) {
  .hero-title-container {
    position: relative;
    z-index: 3;
    margin: -1rem 0 2rem 0;
  }

  .hero-main-visual {
    position: relative;
    z-index: 1;
    margin: -3.5rem 0 1rem 0;
    display: flex;
    justify-content: center;
  }
} */

/* モーダルのスタイル */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-shadow: none;
}

/* スマホ用のモーダルタイトル */
@media (max-width: 768px) {
  .modal-title {
    font-size: 1.2rem;
  }
}

.modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #333;
}

.modal-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
  text-align: left;
}

.required {
  color: #e74c3c;
  margin-left: 4px;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  text-align: left;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #007bff;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  text-align: left;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radio-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
}

.radio-input {
  margin: 0;
  margin-right: 12px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.radio-label {
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-cancel {
  padding: 12px 24px;
  border: 2px solid #ccc;
  background: white;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 150px;
}

.btn-cancel:hover {
  background: #f5f5f5;
  border-color: #999;
}

.btn-submit {
  padding: 12px 24px;
  background: #da3990;
  color: white;
  border: 2px solid #982da6;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 400px;
}

.btn-submit:hover {
  background: #c42d7a;
  border-color: #7a1f8a;
}

.btn-submit:disabled {
  background: #ccc;
  border-color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-cancel:disabled {
  background: #f5f5f5;
  border-color: #ddd;
  cursor: not-allowed;
  opacity: 0.6;
}

.success-message {
  text-align: center;
  padding: 20px;
  margin-bottom: 20px;
}

.success-message p {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 1rem;
  line-height: 1.5;
}

.success-message p:last-of-type {
  margin-bottom: 20px;
}

.btn-download {
  padding: 12px 24px;
  background: #28a745;
  color: white;
  border: 2px solid #1e7e34;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
}

.btn-download:hover {
  background: #218838;
  border-color: #155724;
}

/* レスポンシブデザイン */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-form {
    padding: 20px;
  }

  .form-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn-cancel,
  .btn-submit {
    width: 100%;
    max-width: 100%;
  }
}

/* Jicoo予約フォームモーダルのスタイル */
.schedule-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.schedule-modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.schedule-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  flex-shrink: 0;
}

.schedule-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.schedule-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedule-modal-close:hover {
  color: #333;
}

.schedule-modal-content {
  padding: 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}

.schedule-modal-content .jicoo-widget {
  width: 100%;
  height: 100%;
}

/* モバイル対応 */
@media (max-width: 768px) {
  .schedule-modal {
    width: 95%;
    margin: 10px;
  }

  .schedule-modal-content {
    height: 600px;
  }

  .schedule-modal-content .jicoo-widget {
    min-width: 280px;
  }

  .schedule-modal-header {
    padding: 15px;
  }

  .schedule-modal-header h3 {
    font-size: 16px;
  }
}
</style>
